/**
 * Freguesias (Parishes) of Portugal organized by Concelho (Municipality)
 * Data source: DSSG Portugal (Post-2013 Administrative Reform)
 * Updated via update_freguesias.py
 */

const freguesias = {
  'Abrantes': [
    { designacao: 'Bemposta' },
    { designacao: 'Carvalhal' },
    { designacao: 'Fontes' },
    { designacao: 'Martinchel' },
    { designacao: 'Mouriscas' },
    { designacao: 'Pego' },
    { designacao: 'Rio de Moinhos' },
    { designacao: 'Tramagal' },
    { designacao: 'União das freguesias de Abrantes (São Vicente e São João) e Alferrarede' },
    { designacao: 'União das freguesias de Aldeia do Mato e Souto' },
    { designacao: 'União das freguesias de Alvega e Concavada' },
    { designacao: 'União das freguesias de São Facundo e Vale das Mós' },
    { designacao: 'União das freguesias de São Miguel do Rio Torto e Rossio ao Sul do Tejo' }
  ],
  'Aguiar da Beira': [
    { designacao: 'Carapito' },
    { designacao: 'Cortiçada' },
    { designacao: 'Dornelas' },
    { designacao: 'Eirado' },
    { designacao: 'Forninhos' },
    { designacao: 'Pena Verde' },
    { designacao: 'Pinheiro' },
    { designacao: 'União das freguesias de Aguiar da Beira e Coruche' },
    { designacao: 'União das freguesias de Sequeiros e Gradiz' },
    { designacao: 'União das freguesias de Souto de Aguiar da Beira e Valverde' }
  ],
  'Alandroal': [
    { designacao: 'Capelins (Santo António)' },
    { designacao: 'Santiago Maior' },
    { designacao: 'Terena (São Pedro)' },
    { designacao: 'União das freguesias de Alandroal (Nossa Senhora da Conceição), São Brás dos Matos (Mina do Bugalho) e Juromenha (Nossa Senhora do Loreto)' }
  ],
  'Albergaria-a-Velha': [
    { designacao: 'Albergaria-a-Velha e Valmaior' },
    { designacao: 'Alquerubim' },
    { designacao: 'Angeja' },
    { designacao: 'Branca' },
    { designacao: 'Ribeira de Fráguas' },
    { designacao: 'São João de Loure e Frossos' }
  ],
  'Albufeira': [
    { designacao: 'Albufeira e Olhos de Água' },
    { designacao: 'Ferreiras' },
    { designacao: 'Guia' },
    { designacao: 'Paderne' }
  ],
  'Alcanena': [
    { designacao: 'Bugalhos' },
    { designacao: 'Minde' },
    { designacao: 'Moitas Venda' },
    { designacao: 'Monsanto' },
    { designacao: 'Serra de Santo António' },
    { designacao: 'União das freguesias de Alcanena e Vila Moreira' },
    { designacao: 'União das freguesias de Malhou, Louriceira e Espinheiro' }
  ],
  'Alcobaça': [
    { designacao: 'Alfeizerão' },
    { designacao: 'Aljubarrota' },
    { designacao: 'Benedita' },
    { designacao: 'Bárrio' },
    { designacao: 'Cela' },
    { designacao: 'Maiorga' },
    { designacao: 'São Martinho do Porto' },
    { designacao: 'Turquel' },
    { designacao: 'União das freguesias de Alcobaça e Vestiaria' },
    { designacao: 'União das freguesias de Caldas da Rainha - Santo Onofre e Serra do Bouro' },
    { designacao: 'União das freguesias de Coz, Alpedriz e Montes' },
    { designacao: 'União das freguesias de Pataias e Martingança' },
    { designacao: 'Vimeiro' },
    { designacao: 'Évora de Alcobaça' }
  ],
  'Alcochete': [
    { designacao: 'Alcochete' },
    { designacao: 'Samouco' },
    { designacao: 'São Francisco' }
  ],
  'Alcoutim': [
    { designacao: 'Giões' },
    { designacao: 'Martim Longo' },
    { designacao: 'União das freguesias de Alcoutim e Pereiro' },
    { designacao: 'Vaqueiros' }
  ],
  'Alcácer do Sal': [
    { designacao: 'Comporta' },
    { designacao: 'São Martinho' },
    { designacao: 'Torrão' },
    { designacao: 'União das freguesias de Alcácer do Sal (Santa Maria do Castelo e Santiago) e Santa Susana' }
  ],
  'Alenquer': [
    { designacao: 'Carnota' },
    { designacao: 'Meca' },
    { designacao: 'Olhalvo' },
    { designacao: 'Ota' },
    { designacao: 'União das freguesias de Abrigada e Cabanas de Torres' },
    { designacao: 'União das freguesias de Aldeia Galega da Merceana e Aldeia Gavinha' },
    { designacao: 'União das freguesias de Alenquer (Santo Estêvão e Triana)' },
    { designacao: 'União das freguesias de Carregado e Cadafais' },
    { designacao: 'União das freguesias de Ribafria e Pereiro de Palhacana' },
    { designacao: 'Ventosa' },
    { designacao: 'Vila Verde dos Francos' }
  ],
  'Alfândega da Fé': [
    { designacao: 'Alfândega da Fé' },
    { designacao: 'Cerejais' },
    { designacao: 'Sambade' },
    { designacao: 'União das freguesias de Agrobom, Saldonha e Vale Pereiro' },
    { designacao: 'União das freguesias de Eucisia, Gouveia e Valverde' },
    { designacao: 'União das freguesias de Ferradosa e Sendim da Serra' },
    { designacao: 'União das freguesias de Gebelim e Soeima' },
    { designacao: 'União das freguesias de Parada e Sendim da Ribeira' },
    { designacao: 'União das freguesias de Pombal e Vales' },
    { designacao: 'Vilar Chão' },
    { designacao: 'Vilarelhos' },
    { designacao: 'Vilares de Vilariça' }
  ],
  'Alijó': [
    { designacao: 'Alijó' },
    { designacao: 'Favaios' },
    { designacao: 'Pegarinhos' },
    { designacao: 'Pinhão' },
    { designacao: 'Sanfins do Douro' },
    { designacao: 'Santa Eugénia' },
    { designacao: 'São Mamede de Ribatua' },
    { designacao: 'União das freguesias de Carlão e Amieiro' },
    { designacao: 'União das freguesias de Castedo e Cotas' },
    { designacao: 'União das freguesias de Pópulo e Ribalonga' },
    { designacao: 'União das freguesias de Vale de Mendiz, Casal de Loivos e Vilarinho de Cotas' },
    { designacao: 'Vila Chã' },
    { designacao: 'Vila Verde' },
    { designacao: 'Vilar de Maçada' }
  ],
  'Aljezur': [
    { designacao: 'Aljezur' },
    { designacao: 'Bordeira' },
    { designacao: 'Odeceixe' },
    { designacao: 'Rogil' }
  ],
  'Aljustrel': [
    { designacao: 'Ervidel' },
    { designacao: 'Messejana' },
    { designacao: 'São João de Negrilhos' },
    { designacao: 'União das freguesias de Aljustrel e Rio de Moinhos' }
  ],
  'Almada': [
    { designacao: 'Costa da Caparica' },
    { designacao: 'União das freguesias de Almada, Cova da Piedade, Pragal e Cacilhas' },
    { designacao: 'União das freguesias de Caparica e Trafaria' },
    { designacao: 'União das freguesias de Charneca de Caparica e Sobreda' },
    { designacao: 'União das freguesias de Laranjeiro e Feijó' }
  ],
  'Almeida': [
    { designacao: 'Almeida' },
    { designacao: 'Castelo Bom' },
    { designacao: 'Freineda' },
    { designacao: 'Freixo' },
    { designacao: 'Malhada Sorda' },
    { designacao: 'Nave de Haver' },
    { designacao: 'São Pedro de Rio Seco' },
    { designacao: 'União das freguesias de Amoreira, Parada e Cabreira' },
    { designacao: 'União das freguesias de Azinhal, Peva e Valverde' },
    { designacao: 'União das freguesias de Castelo Mendo, Ade, Monteperobolso e Mesquitela' },
    { designacao: 'União das freguesias de Junça e Naves' },
    { designacao: 'União das freguesias de Leomil, Mido, Senouras e Aldeia Nova' },
    { designacao: 'União das freguesias de Malpartida e Vale de Coelha' },
    { designacao: 'União das freguesias de Miuzela e Porto de Ovelha' },
    { designacao: 'Vale da Mula' },
    { designacao: 'Vilar Formoso' }
  ],
  'Almeirim': [
    { designacao: 'Almeirim' },
    { designacao: 'Benfica do Ribatejo' },
    { designacao: 'Fazendas de Almeirim' },
    { designacao: 'Raposa' }
  ],
  'Almodôvar': [
    { designacao: 'Aldeia dos Fernandes' },
    { designacao: 'Rosário' },
    { designacao: 'Santa Cruz' },
    { designacao: 'São Barnabé' },
    { designacao: 'União das freguesias de Almodôvar e Graça dos Padrões' },
    { designacao: 'União das freguesias de Santa Clara-a-Nova e Gomes Aires' }
  ],
  'Alpiarça': [
    { designacao: 'Alpiarça' }
  ],
  'Alter do Chão': [
    { designacao: 'Alter do Chão' },
    { designacao: 'Chancelaria' },
    { designacao: 'Cunheira' },
    { designacao: 'Seda' }
  ],
  'Alvaiázere': [
    { designacao: 'Almoster' },
    { designacao: 'Alvaiázere' },
    { designacao: 'Igreja Nova do Sobral' },
    { designacao: 'Maçãs de Dona Maria' },
    { designacao: 'Pelmá' },
    { designacao: 'Pussos São Pedro' }
  ],
  'Alvito': [
    { designacao: 'Alvito' },
    { designacao: 'Vila Nova da Baronia' }
  ],
  'Amadora': [
    { designacao: 'Alfragide' },
    { designacao: 'Encosta do Sol' },
    { designacao: 'Falagueira - Venda Nova' },
    { designacao: 'Mina de Água' },
    { designacao: 'Venteira' },
    { designacao: 'Águas Livres' }
  ],
  'Amarante': [
    { designacao: 'Ansiães' },
    { designacao: 'Candemil' },
    { designacao: 'Fregim' },
    { designacao: 'Fridão' },
    { designacao: 'Gondar' },
    { designacao: 'Gouveia (São Simão)' },
    { designacao: 'Jazente' },
    { designacao: 'Lomba' },
    { designacao: 'Louredo' },
    { designacao: 'Lufrei' },
    { designacao: 'Mancelos' },
    { designacao: 'Padronelo' },
    { designacao: 'Rebordelo' },
    { designacao: 'Salvador do Monte' },
    { designacao: 'Telões' },
    { designacao: 'Travanca' },
    { designacao: 'União das freguesias de Aboadela, Sanche e Várzea' },
    { designacao: 'União das freguesias de Amarante (São Gonçalo), Madalena, Cepelos e Gatão' },
    { designacao: 'União das freguesias de Bustelo, Carneiro e Carvalho de Rei' },
    { designacao: 'União das freguesias de Figueiró (Santiago e Santa Cristina)' },
    { designacao: 'União das freguesias de Freixo de Cima e de Baixo' },
    { designacao: 'União das freguesias de Olo e Canadelo' },
    { designacao: 'União das freguesias de Real, Ataíde e Oliveira' },
    { designacao: 'União das freguesias de Vila Garcia, Aboim e Chapa' },
    { designacao: 'Vila Caiz' },
    { designacao: 'Vila Chã do Marão' }
  ],
  'Amares': [
    { designacao: 'Barreiros' },
    { designacao: 'Bico' },
    { designacao: 'Bouro (Santa Maria)' },
    { designacao: 'Bouro (Santa Marta)' },
    { designacao: 'Caires' },
    { designacao: 'Carrazedo' },
    { designacao: 'Dornelas' },
    { designacao: 'Fiscal' },
    { designacao: 'Goães' },
    { designacao: 'Lago' },
    { designacao: 'Rendufe' },
    { designacao: 'União das freguesias de Amares e Figueiredo' },
    { designacao: 'União das freguesias de Caldelas, Sequeiros e Paranhos' },
    { designacao: 'União das freguesias de Ferreiros, Prozelo e Besteiros' },
    { designacao: 'União das freguesias de Torre e Portela' },
    { designacao: 'União das freguesias de Vilela, Seramil e Paredes Secas' }
  ],
  'Anadia': [
    { designacao: 'Avelãs de Caminho' },
    { designacao: 'Avelãs de Cima' },
    { designacao: 'Moita' },
    { designacao: 'Sangalhos' },
    { designacao: 'São Lourenço do Bairro' },
    { designacao: 'União das freguesias de Amoreira da Gândara, Paredes do Bairro e Ancas' },
    { designacao: 'União das freguesias de Arcos e Mogofores' },
    { designacao: 'União das freguesias de Tamengos, Aguim e Óis do Bairro' },
    { designacao: 'Vila Nova de Monsarros' },
    { designacao: 'Vilarinho do Bairro' }
  ],
  'Angra do Heroísmo': [
    { designacao: 'Altares' },
    { designacao: 'Angra (Nossa Senhora da Conceição)' },
    { designacao: 'Angra (Santa Luzia)' },
    { designacao: 'Angra (São Pedro)' },
    { designacao: 'Angra (Sé)' },
    { designacao: 'Cinco Ribeiras' },
    { designacao: 'Doze Ribeiras' },
    { designacao: 'Feteira' },
    { designacao: 'Porto Judeu' },
    { designacao: 'Posto Santo' },
    { designacao: 'Raminho' },
    { designacao: 'Ribeirinha' },
    { designacao: 'Santa Bárbara' },
    { designacao: 'Serreta' },
    { designacao: 'São Bartolomeu de Regatos' },
    { designacao: 'São Bento' },
    { designacao: 'São Mateus da Calheta' },
    { designacao: 'Terra Chã' },
    { designacao: 'Vila de São Sebastião' }
  ],
  'Ansião': [
    { designacao: 'Abiul' },
    { designacao: 'Alvorge' },
    { designacao: 'Ansião' },
    { designacao: 'Avelar' },
    { designacao: 'Chão de Couce' },
    { designacao: 'Pousaflores' },
    { designacao: 'Santiago da Guarda' }
  ],
  'Arcos de Valdevez': [
    { designacao: 'Aboim das Choças' },
    { designacao: 'Aguiã' },
    { designacao: 'Cabana Maior' },
    { designacao: 'Cabreiro' },
    { designacao: 'Cendufe' },
    { designacao: 'Couto' },
    { designacao: 'Gavieira' },
    { designacao: 'Gondoriz' },
    { designacao: 'Jolda (São Paio)' },
    { designacao: 'Miranda' },
    { designacao: 'Monte Redondo' },
    { designacao: 'Oliveira' },
    { designacao: 'Padroso' },
    { designacao: 'Paçô' },
    { designacao: 'Prozelo' },
    { designacao: 'Rio Frio' },
    { designacao: 'Rio de Moinhos' },
    { designacao: 'Sabadim' },
    { designacao: 'Senharei' },
    { designacao: 'Sistelo' },
    { designacao: 'Soajo' },
    { designacao: 'União das freguesias de Alvora e Loureda' },
    { designacao: 'União das freguesias de Arcos de Valdevez (Salvador), Vila Fonche e Parada' },
    { designacao: 'União das freguesias de Arcos de Valdevez (São Paio) e Giela' },
    { designacao: 'União das freguesias de Eiras e Mei' },
    { designacao: 'União das freguesias de Grade e Carralcova' },
    { designacao: 'União das freguesias de Guilhadeses e Santar' },
    { designacao: 'União das freguesias de Jolda (Madalena) e Rio Cabrão' },
    { designacao: 'União das freguesias de Padreiro (Salvador e Santa Cristina)' },
    { designacao: 'União das freguesias de Portela e Extremo' },
    { designacao: 'União das freguesias de Souto e Tabaçô' },
    { designacao: 'União das freguesias de São Jorge e Ermelo' },
    { designacao: 'União das freguesias de Távora (Santa Maria e São Vicente)' },
    { designacao: 'União das freguesias de Vilela, São Cosme e São Damião e Sá' },
    { designacao: 'Vale' },
    { designacao: 'Ázere' }
  ],
  'Arganil': [
    { designacao: 'Arganil' },
    { designacao: 'Benfeita' },
    { designacao: 'Celavisa' },
    { designacao: 'Folques' },
    { designacao: 'Piódão' },
    { designacao: 'Pomares' },
    { designacao: 'Pombeiro da Beira' },
    { designacao: 'Sarzedo' },
    { designacao: 'Secarias' },
    { designacao: 'São Martinho da Cortiça' },
    { designacao: 'União das freguesias de Cepos e Teixeira' },
    { designacao: 'União das freguesias de Cerdeira e Moura da Serra' },
    { designacao: 'União das freguesias de Côja e Barril de Alva' },
    { designacao: 'União das freguesias de Friúmes e Paradela' },
    { designacao: 'União das freguesias de São Pedro de Alva e São Paio de Mondego' },
    { designacao: 'União das freguesias de Vila Cova de Alva e Anseriz' }
  ],
  'Armamar': [
    { designacao: 'Aldeias' },
    { designacao: 'Armamar' },
    { designacao: 'Cimbres' },
    { designacao: 'Folgosa' },
    { designacao: 'Fontelo' },
    { designacao: 'Queimada' },
    { designacao: 'Queimadela' },
    { designacao: 'Santa Cruz' },
    { designacao: 'São Cosmado' },
    { designacao: 'São Martinho das Chãs' },
    { designacao: 'União das freguesias de Aricera e Goujoim' },
    { designacao: 'União das freguesias de São Romão e Santiago' },
    { designacao: 'União das freguesias de Vila Seca e Santo Adrião' },
    { designacao: 'Vacalar' }
  ],
  'Arouca': [
    { designacao: 'Alvarenga' },
    { designacao: 'Chave' },
    { designacao: 'Escariz' },
    { designacao: 'Fermedo' },
    { designacao: 'Mansores' },
    { designacao: 'Moldes' },
    { designacao: 'Rossas' },
    { designacao: 'Santa Eulália' },
    { designacao: 'São Miguel do Mato' },
    { designacao: 'Tropeço' },
    { designacao: 'União das freguesias de Arouca e Burgo' },
    { designacao: 'União das freguesias de Cabreiros e Albergaria da Serra' },
    { designacao: 'União das freguesias de Canelas e Espiunca' },
    { designacao: 'União das freguesias de Covelo de Paivó e Janarde' },
    { designacao: 'Urrô' },
    { designacao: 'Várzea' }
  ],
  'Arraiolos': [
    { designacao: 'Arraiolos' },
    { designacao: 'Igrejinha' },
    { designacao: 'União das freguesias de Gafanhoeira (São Pedro) e Sabugueiro' },
    { designacao: 'União das freguesias de São Gregório e Santa Justa' },
    { designacao: 'Vimieiro' }
  ],
  'Arronches': [
    { designacao: 'Assunção' },
    { designacao: 'Esperança' },
    { designacao: 'Mosteiros' }
  ],
  'Arruda dos Vinhos': [
    { designacao: 'Arranhó' },
    { designacao: 'Arruda dos Vinhos' },
    { designacao: 'Cardosas' },
    { designacao: 'Santiago dos Velhos' },
    { designacao: 'Sapataria' }
  ],
  'Aveiro': [
    { designacao: 'Aradas' },
    { designacao: 'Cacia' },
    { designacao: 'Eixo e Eirol' },
    { designacao: 'Esgueira' },
    { designacao: 'Oliveirinha' },
    { designacao: 'Requeixo, Nossa Senhora de Fátima e Nariz' },
    { designacao: 'Santa Joana' },
    { designacao: 'São Bernardo' },
    { designacao: 'São Jacinto' },
    { designacao: 'União das freguesias de Glória e Vera Cruz' }
  ],
  'Avis': [
    { designacao: 'Aldeia Velha' },
    { designacao: 'Avis' },
    { designacao: 'Ervedal' },
    { designacao: 'Figueira e Barros' },
    { designacao: 'União das freguesias de Alcórrego e Maranhão' },
    { designacao: 'União das freguesias de Benavila e Valongo' }
  ],
  'Azambuja': [
    { designacao: 'Alcoentre' },
    { designacao: 'Aveiras de Baixo' },
    { designacao: 'Aveiras de Cima' },
    { designacao: 'Azambuja' },
    { designacao: 'União das freguesias de Manique do Intendente, Vila Nova de São Pedro e Maçussa' },
    { designacao: 'Vale do Paraíso' },
    { designacao: 'Vila Nova da Rainha' }
  ],
  'Baião': [
    { designacao: 'Frende' },
    { designacao: 'Gestaçô' },
    { designacao: 'Gove' },
    { designacao: 'Grilo' },
    { designacao: 'Loivos do Monte' },
    { designacao: 'Santa Marinha do Zêzere' },
    { designacao: 'União das freguesias de Ancede e Ribadouro' },
    { designacao: 'União das freguesias de Baião (Santa Leocádia) e Mesquinhata' },
    { designacao: 'União das freguesias de Campelo e Ovil' },
    { designacao: 'União das freguesias de Loivos da Ribeira e Tresouras' },
    { designacao: 'União das freguesias de Santa Cruz do Douro e São Tomé de Covelas' },
    { designacao: 'União das freguesias de Teixeira e Teixeiró' },
    { designacao: 'Valadares' },
    { designacao: 'Viariz' }
  ],
  'Barcelos': [
    { designacao: 'Abade de Neiva' },
    { designacao: 'Aborim' },
    { designacao: 'Adães' },
    { designacao: 'Airó' },
    { designacao: 'Aldreu' },
    { designacao: 'Alvelos' },
    { designacao: 'Arcozelo' },
    { designacao: 'Areias' },
    { designacao: 'Balugães' },
    { designacao: 'Barcelinhos' },
    { designacao: 'Barqueiros' },
    { designacao: 'Cambeses' },
    { designacao: 'Carapeços' },
    { designacao: 'Carvalhal' },
    { designacao: 'Carvalhas' },
    { designacao: 'Cossourado' },
    { designacao: 'Cristelo' },
    { designacao: 'Fornelos' },
    { designacao: 'Fragoso' },
    { designacao: 'Galegos (Santa Maria)' },
    { designacao: 'Galegos (São Martinho)' },
    { designacao: 'Gilmonde' },
    { designacao: 'Lama' },
    { designacao: 'Lijó' },
    { designacao: 'Macieira de Rates' },
    { designacao: 'Manhente' },
    { designacao: 'Martim' },
    { designacao: 'Moure' },
    { designacao: 'Oliveira' },
    { designacao: 'Palme' },
    { designacao: 'Panque' },
    { designacao: 'Paradela' },
    { designacao: 'Pereira' },
    { designacao: 'Perelhal' },
    { designacao: 'Pousa' },
    { designacao: 'Remelhe' },
    { designacao: 'Rio Covo (Santa Eugénia)' },
    { designacao: 'Roriz' },
    { designacao: 'Silva' },
    { designacao: 'Tamel (São Veríssimo)' },
    { designacao: 'Ucha' },
    { designacao: 'União das freguesias de Alheira e Igreja Nova' },
    { designacao: 'União das freguesias de Alvito (São Pedro e São Martinho) e Couto' },
    { designacao: 'União das freguesias de Areias de Vilar e Encourados' },
    { designacao: 'União das freguesias de Barcelos, Vila Boa e Vila Frescainha (São Martinho e São Pedro)' },
    { designacao: 'União das freguesias de Barroselas e Carvoeiro' },
    { designacao: 'União das freguesias de Campo e Tamel (São Pedro Fins)' },
    { designacao: 'União das freguesias de Carreira e Fonte Coberta' },
    { designacao: 'União das freguesias de Chorente, Góios, Courel, Pedra Furada e Gueral' },
    { designacao: 'União das freguesias de Creixomil e Mariz' },
    { designacao: 'União das freguesias de Durrães e Tregosa' },
    { designacao: 'União das freguesias de Gamil e Midões' },
    { designacao: 'União das freguesias de Milhazes, Vilar de Figos e Faria' },
    { designacao: 'União das freguesias de Negreiros e Chavão' },
    { designacao: 'União das freguesias de Quintiães e Aguiar' },
    { designacao: 'União das freguesias de Sequeade e Bastuço (São João e Santo Estevão)' },
    { designacao: 'União das freguesias de Silveiros e Rio Covo (Santa Eulália)' },
    { designacao: 'União das freguesias de Tamel (Santa Leocádia) e Vilar do Monte' },
    { designacao: 'União das freguesias de Viatodos, Grimancelos, Minhotães e Monte de Fralães' },
    { designacao: 'União das freguesias de Vila Cova e Feitos' },
    { designacao: 'Vila Seca' },
    { designacao: 'Várzea' }
  ],
  'Barrancos': [
    { designacao: 'Barrancos' }
  ],
  'Barreiro': [
    { designacao: 'Santo António da Charneca' },
    { designacao: 'União das freguesias de Alto do Seixalinho, Santo André e Verderena' },
    { designacao: 'União das freguesias de Barreiro e Lavradio' },
    { designacao: 'União das freguesias de Palhais e Coina' }
  ],
  'Batalha': [
    { designacao: 'Batalha' },
    { designacao: 'Golpilheira' },
    { designacao: 'Reguengo do Fetal' },
    { designacao: 'São Mamede' }
  ],
  'Beja': [
    { designacao: 'Baleizão' },
    { designacao: 'Beringel' },
    { designacao: 'Cabeça Gorda' },
    { designacao: 'Nossa Senhora das Neves' },
    { designacao: 'Santa Clara de Louredo' },
    { designacao: 'São Matias' },
    { designacao: 'União das freguesias de Albernoa e Trindade' },
    { designacao: 'União das freguesias de Beja (Salvador e Santa Maria da Feira)' },
    { designacao: 'União das freguesias de Beja (Santiago Maior e São João Baptista)' },
    { designacao: 'União das freguesias de Salvada e Quintos' },
    { designacao: 'União das freguesias de Santa Vitória e Mombeja' },
    { designacao: 'União das freguesias de Trigaches e São Brissos' }
  ],
  'Belmonte': [
    { designacao: 'Caria' },
    { designacao: 'Inguias' },
    { designacao: 'Maçainhas' },
    { designacao: 'União das freguesias de Belmonte e Colmeal da Torre' }
  ],
  'Benavente': [
    { designacao: 'Barrosa' },
    { designacao: 'Benavente' },
    { designacao: 'Samora Correia' },
    { designacao: 'Santo Estêvão' }
  ],
  'Bombarral': [
    { designacao: 'Carvalhal' },
    { designacao: 'Pó' },
    { designacao: 'Roliça' },
    { designacao: 'União das freguesias de Bombarral e Vale Covo' }
  ],
  'Borba': [
    { designacao: 'Borba (Matriz)' },
    { designacao: 'Borba (São Bartolomeu)' },
    { designacao: 'Orada' },
    { designacao: 'Rio de Moinhos' },
    { designacao: 'União das freguesias de Alandroal (Nossa Senhora da Conceição), São Brás dos Matos (Mina do Bugalho) e Juromenha (Nossa Senhora do Loreto)' }
  ],
  'Boticas': [
    { designacao: 'Alturas do Barroso e Cerdedo' },
    { designacao: 'Ardãos e Bobadela' },
    { designacao: 'Beça' },
    { designacao: 'Boticas e Granja' },
    { designacao: 'Codessoso, Curros e Fiães do Tâmega' },
    { designacao: 'Covas do Barroso' },
    { designacao: 'Dornelas' },
    { designacao: 'Pinho' },
    { designacao: 'Sapiãos' },
    { designacao: 'Vilar e Viveiro' }
  ],
  'Braga': [
    { designacao: 'Adaúfe' },
    { designacao: 'Braga (São Vicente)' },
    { designacao: 'Braga (São Vítor)' },
    { designacao: 'Espinho' },
    { designacao: 'Esporões' },
    { designacao: 'Figueiredo' },
    { designacao: 'Gualtar' },
    { designacao: 'Lamas' },
    { designacao: 'Mire de Tibães' },
    { designacao: 'Padim da Graça' },
    { designacao: 'Palmeira' },
    { designacao: 'Pedralva' },
    { designacao: 'Priscos' },
    { designacao: 'Ruilhe' },
    { designacao: 'Sequeira' },
    { designacao: 'Sobreposta' },
    { designacao: 'Tadim' },
    { designacao: 'Tebosa' },
    { designacao: 'União das freguesias de Arentim e Cunha' },
    { designacao: 'União das freguesias de Braga (Maximinos, Sé e Cividade)' },
    { designacao: 'União das freguesias de Braga (São José de São Lázaro e São João do Souto)' },
    { designacao: 'União das freguesias de Cabreiros e Passos (São Julião)' },
    { designacao: 'União das freguesias de Celeirós, Aveleda e Vimieiro' },
    { designacao: 'União das freguesias de Crespos e Pousada' },
    { designacao: 'União das freguesias de Escudeiros e Penso (Santo Estêvão e São Vicente)' },
    { designacao: 'União das freguesias de Este (São Pedro e São Mamede)' },
    { designacao: 'União das freguesias de Ferreiros e Gondizalves' },
    { designacao: 'União das freguesias de Guisande e Oliveira (São Pedro)' },
    { designacao: 'União das freguesias de Lomar e Arcos' },
    { designacao: 'União das freguesias de Merelim (São Paio), Panoias e Parada de Tibães' },
    { designacao: 'União das freguesias de Merelim (São Pedro) e Frossos' },
    { designacao: 'União das freguesias de Morreira e Trandeiras' },
    { designacao: 'União das freguesias de Nogueira, Fraião e Lamaçães' },
    { designacao: 'União das freguesias de Nogueiró e Tenões' },
    { designacao: 'União das freguesias de Real, Dume e Semelhe' },
    { designacao: 'União das freguesias de Santa Lucrécia de Algeriz e Navarra' },
    { designacao: 'União das freguesias de Vilaça e Fradelos' }
  ],
  'Bragança': [
    { designacao: 'Alfaião' },
    { designacao: 'Babe' },
    { designacao: 'Baçal' },
    { designacao: 'Carragosa' },
    { designacao: 'Castro de Avelãs' },
    { designacao: 'Coelhoso' },
    { designacao: 'Donai' },
    { designacao: 'Espinhosela' },
    { designacao: 'França' },
    { designacao: 'Gimonde' },
    { designacao: 'Gondesende' },
    { designacao: 'Gostei' },
    { designacao: 'Grijó de Parada' },
    { designacao: 'Macedo do Mato' },
    { designacao: 'Mós' },
    { designacao: 'Nogueira' },
    { designacao: 'Outeiro' },
    { designacao: 'Parâmio' },
    { designacao: 'Pinela' },
    { designacao: 'Quintanilha' },
    { designacao: 'Quintela de Lampaças' },
    { designacao: 'Rabal' },
    { designacao: 'Rebordãos' },
    { designacao: 'Salsas' },
    { designacao: 'Samil' },
    { designacao: 'Santa Comba de Rossas' },
    { designacao: 'Sendas' },
    { designacao: 'Serapicos' },
    { designacao: 'Sortes' },
    { designacao: 'União das freguesias de Aveleda e Rio de Onor' },
    { designacao: 'União das freguesias de Castrelos e Carrazedo' },
    { designacao: 'União das freguesias de Izeda, Calvelhe e Paradinha Nova' },
    { designacao: 'União das freguesias de Parada e Faílde' },
    { designacao: 'União das freguesias de Rebordainhos e Pombares' },
    { designacao: 'União das freguesias de Rio Frio e Milhão' },
    { designacao: 'União das freguesias de São Julião de Palácios e Deilão' },
    { designacao: 'União das freguesias de Sé, Santa Maria e Meixedo' },
    { designacao: 'Zoio' }
  ],
  'Cabeceiras de Basto': [
    { designacao: 'Abadim' },
    { designacao: 'Basto' },
    { designacao: 'Bucos' },
    { designacao: 'Cabeceiras de Basto' },
    { designacao: 'Cavez' },
    { designacao: 'Faia' },
    { designacao: 'Pedraça' },
    { designacao: 'Rio Douro' },
    { designacao: 'União das freguesias de Alvite e Passos' },
    { designacao: 'União das freguesias de Arco de Baúlhe e Vila Nune' },
    { designacao: 'União das freguesias de Gondiães e Vilar de Cunhas' },
    { designacao: 'União das freguesias de Refojos de Basto, Outeiro e Painzela' }
  ],
  'Cadaval': [
    { designacao: 'Alguber' },
    { designacao: 'Peral' },
    { designacao: 'União das freguesias de Lamas e Cercal' },
    { designacao: 'União das freguesias de Painho e Figueiros' },
    { designacao: 'União das freguesias do Cadaval e Pêro Moniz' },
    { designacao: 'Vermelha' },
    { designacao: 'Vilar' }
  ],
  'Caldas da Rainha': [
    { designacao: 'A dos Francos' },
    { designacao: 'Alvorninha' },
    { designacao: 'Carvalhal Benfeito' },
    { designacao: 'Foz do Arelho' },
    { designacao: 'Landal' },
    { designacao: 'Nadadouro' },
    { designacao: 'Salir de Matos' },
    { designacao: 'Santa Catarina' },
    { designacao: 'União das freguesias de Caldas da Rainha - Nossa Senhora do Pópulo, Coto e São Gregório' },
    { designacao: 'União das freguesias de Caldas da Rainha - Santo Onofre e Serra do Bouro' },
    { designacao: 'União das freguesias de Tornada e Salir do Porto' },
    { designacao: 'Vidais' }
  ],
  'Calheta': [
    { designacao: 'Arco da Calheta' },
    { designacao: 'Calheta (R.A.Açores)' },
    { designacao: 'Calheta (R.A.Madeira)' },
    { designacao: 'Estreito da Calheta' },
    { designacao: 'Fajã da Ovelha' },
    { designacao: 'Jardim do Mar' },
    { designacao: 'Norte Pequeno (R.A.Açores)' },
    { designacao: 'Paul do Mar' },
    { designacao: 'Ponta do Pargo' },
    { designacao: 'Prazeres' },
    { designacao: 'Ribeira Seca (R.A.Açores)' },
    { designacao: 'Santo Antão (R.A.Açores)' },
    { designacao: 'Topo (Nossa Senhora do Rosário)(R.A.Açores)' }
  ],
  'Caminha': [
    { designacao: 'Argela' },
    { designacao: 'Dem' },
    { designacao: 'Lanhelas' },
    { designacao: 'Riba de Âncora' },
    { designacao: 'Seixas' },
    { designacao: 'União das freguesias de Arga (Baixo, Cima e São João)' },
    { designacao: 'União das freguesias de Caminha (Matriz) e Vilarelho' },
    { designacao: 'União das freguesias de Gondar e Orbacém' },
    { designacao: 'União das freguesias de Moledo e Cristelo' },
    { designacao: 'União das freguesias de Venade e Azevedo' },
    { designacao: 'Vila Praia de Âncora' },
    { designacao: 'Vilar de Mouros' },
    { designacao: 'Vile' },
    { designacao: 'Âncora' }
  ],
  'Campo Maior': [
    { designacao: 'Nossa Senhora da Expectação' },
    { designacao: 'Nossa Senhora da Graça dos Degolados' },
    { designacao: 'São João Baptista' }
  ],
  'Cantanhede': [
    { designacao: 'Ançã' },
    { designacao: 'Cadima' },
    { designacao: 'Cordinhã' },
    { designacao: 'Febres' },
    { designacao: 'Murtede' },
    { designacao: 'Ourentã' },
    { designacao: 'Sanguinheira' },
    { designacao: 'São Caetano' },
    { designacao: 'Tocha' },
    { designacao: 'União das freguesias de Cantanhede e Pocariça' },
    { designacao: 'União das freguesias de Covões e Camarneira' },
    { designacao: 'União das freguesias de Portunhos e Outil' },
    { designacao: 'União das freguesias de Sepins e Bolho' },
    { designacao: 'União das freguesias de Vilamar e Corticeiro de Cima' }
  ],
  'Carrazeda de Ansiães': [
    { designacao: 'Carrazeda de Ansiães' },
    { designacao: 'Fonte Longa' },
    { designacao: 'Linhares' },
    { designacao: 'Marzagão' },
    { designacao: 'Parambos' },
    { designacao: 'Pereiros' },
    { designacao: 'Pinhal do Norte' },
    { designacao: 'Pombal' },
    { designacao: 'Seixo de Ansiães' },
    { designacao: 'União das freguesias de Amedo e Zedes' },
    { designacao: 'União das freguesias de Belver e Mogo de Malta' },
    { designacao: 'União das freguesias de Castanheiro do Norte e Ribalonga' },
    { designacao: 'União das freguesias de Lavandeira, Beira Grande e Selores' },
    { designacao: 'Vilarinho da Castanheira' }
  ],
  'Carregal do Sal': [
    { designacao: 'Beijós' },
    { designacao: 'Cabanas de Viriato' },
    { designacao: 'Oliveira do Conde' },
    { designacao: 'Parada' },
    { designacao: 'União das freguesias de Currelos, Papízios e Sobral' }
  ],
  'Cartaxo': [
    { designacao: 'Pontével' },
    { designacao: 'União das freguesias de Cartaxo e Vale da Pinta' },
    { designacao: 'União das freguesias de Ereira e Lapa' },
    { designacao: 'Valada' },
    { designacao: 'Vale da Pedra' },
    { designacao: 'Vila Chã de Ourique' }
  ],
  'Cascais': [
    { designacao: 'Alcabideche' },
    { designacao: 'São Domingos de Rana' },
    { designacao: 'União das freguesias de Carcavelos e Parede' },
    { designacao: 'União das freguesias de Cascais e Estoril' }
  ],
  'Castanheira de Pêra': [
    { designacao: 'União das freguesias de Castanheira de Pêra e Coentral' }
  ],
  'Castelo Branco': [
    { designacao: 'Alcains' },
    { designacao: 'Almaceda' },
    { designacao: 'Benquerenças' },
    { designacao: 'Castelo Branco' },
    { designacao: 'Lardosa' },
    { designacao: 'Louriçal do Campo' },
    { designacao: 'Malpica do Tejo' },
    { designacao: 'Monforte da Beira' },
    { designacao: 'Salgueiro do Campo' },
    { designacao: 'Santo André das Tojeiras' },
    { designacao: 'Sarzedas' },
    { designacao: 'São Vicente da Beira' },
    { designacao: 'Tinalhas' },
    { designacao: 'União das freguesias de Cebolais de Cima e Retaxo' },
    { designacao: 'União das freguesias de Escalos de Baixo e Mata' },
    { designacao: 'União das freguesias de Escalos de Cima e Lousa' },
    { designacao: 'União das freguesias de Freixial e Juncal do Campo' },
    { designacao: 'União das freguesias de Ninho do Açor e Sobral do Campo' },
    { designacao: 'União das freguesias de Póvoa de Rio de Moinhos e Cafede' }
  ],
  'Castelo de Paiva': [
    { designacao: 'Fornos' },
    { designacao: 'Real' },
    { designacao: 'Santa Maria de Sardoura' },
    { designacao: 'São Martinho de Sardoura' },
    { designacao: 'União das freguesias de Raiva, Pedorido e Paraíso' },
    { designacao: 'União das freguesias de Sobrado e Bairros' }
  ],
  'Castelo de Vide': [
    { designacao: 'Nossa Senhora da Graça de Póvoa e Meadas' },
    { designacao: 'Santa Maria da Devesa' },
    { designacao: 'Santiago Maior' },
    { designacao: 'São João Baptista' }
  ],
  'Castro Daire': [
    { designacao: 'Almofala' },
    { designacao: 'Cabril' },
    { designacao: 'Castro Daire' },
    { designacao: 'Cujó' },
    { designacao: 'Gosende' },
    { designacao: 'Moledo' },
    { designacao: 'Monteiras' },
    { designacao: 'Mões' },
    { designacao: 'Pepim' },
    { designacao: 'Pinheiro' },
    { designacao: 'São Joaninho' },
    { designacao: 'União das freguesias de Mamouros, Alva e Ribolhos' },
    { designacao: 'União das freguesias de Mezio e Moura Morta' },
    { designacao: 'União das freguesias de Parada de Ester e Ester' },
    { designacao: 'União das freguesias de Picão e Ermida' },
    { designacao: 'União das freguesias de Reriz e Gafanhão' }
  ],
  'Castro Marim': [
    { designacao: 'Altura' },
    { designacao: 'Azinhal' },
    { designacao: 'Castro Marim' },
    { designacao: 'Odeleite' }
  ],
  'Castro Verde': [
    { designacao: 'Entradas' },
    { designacao: 'Santa Bárbara de Padrões' },
    { designacao: 'São Marcos da Ataboeira' },
    { designacao: 'União das freguesias de Castro Verde e Casével' }
  ],
  'Celorico da Beira': [
    { designacao: 'Baraçal' },
    { designacao: 'Carrapichana' },
    { designacao: 'Casas do Soeiro' },
    { designacao: 'Forno Telheiro' },
    { designacao: 'Lajeosa do Mondego' },
    { designacao: 'Linhares' },
    { designacao: 'Maçal do Chão' },
    { designacao: 'Mesquitela' },
    { designacao: 'Minhocal' },
    { designacao: 'Prados' },
    { designacao: 'Ratoeira' },
    { designacao: 'União das freguesias de Açores e Velosa' },
    { designacao: 'União das freguesias de Celorico (São Pedro e Santa Maria) e Vila Boa do Mondego' },
    { designacao: 'União das freguesias de Cortiçô da Serra, Vide Entre Vinhas e Salgueirais' },
    { designacao: 'União das freguesias de Rapa e Cadafaz' },
    { designacao: 'Vale de Azares' }
  ],
  'Celorico de Basto': [
    { designacao: 'Agilde' },
    { designacao: 'Arnóia' },
    { designacao: 'Basto (São Clemente)' },
    { designacao: 'Borba de Montanha' },
    { designacao: 'Codeçoso' },
    { designacao: 'Fervença' },
    { designacao: 'Moreira do Castelo' },
    { designacao: 'Rego' },
    { designacao: 'Ribas' },
    { designacao: 'União das freguesias de Britelo, Gémeos e Ourilhe' },
    { designacao: 'União das freguesias de Canedo de Basto e Corgo' },
    { designacao: 'União das freguesias de Carvalho e Basto (Santa Tecla)' },
    { designacao: 'União das freguesias de Caçarilhe e Infesta' },
    { designacao: 'União das freguesias de Veade, Gagos e Molares' },
    { designacao: 'Vale de Bouro' }
  ],
  'Chamusca': [
    { designacao: 'Carregueira' },
    { designacao: 'Ulme' },
    { designacao: 'União das freguesias da Chamusca e Pinheiro Grande' },
    { designacao: 'União das freguesias de Parreira e Chouto' },
    { designacao: 'Vale de Cavalos' }
  ],
  'Chaves': [
    { designacao: 'Anelhe' },
    { designacao: 'Bustelo' },
    { designacao: 'Cimo de Vila da Castanheira' },
    { designacao: 'Curalha' },
    { designacao: 'Ervededo' },
    { designacao: 'Faiões' },
    { designacao: 'Lama de Arcos' },
    { designacao: 'Mairos' },
    { designacao: 'Moreiras' },
    { designacao: 'Nogueira da Montanha' },
    { designacao: 'Oura' },
    { designacao: 'Outeiro Seco' },
    { designacao: 'Paradela' },
    { designacao: 'Planalto de Monforte (União das freguesias de Oucidres e Bobadela)' },
    { designacao: 'Redondelo' },
    { designacao: 'Sanfins' },
    { designacao: 'Santa Leocádia' },
    { designacao: 'Santa Maria Maior' },
    { designacao: 'Santo António de Monforte' },
    { designacao: 'Santo Estêvão' },
    { designacao: 'São Pedro de Agostém' },
    { designacao: 'São Vicente' },
    { designacao: 'Tronco' },
    { designacao: 'União das freguesias da Madalena e Samaiões' },
    { designacao: 'União das freguesias das Eiras, São Julião de Montenegro e Cela' },
    { designacao: 'União das freguesias de Calvão e Soutelinho da Raia' },
    { designacao: 'União das freguesias de Loivos e Póvoa de Agrações' },
    { designacao: 'União das freguesias de Santa Cruz/Trindade e Sanjurge' },
    { designacao: 'União das freguesias de Soutelo e Seara Velha' },
    { designacao: 'União das freguesias de Travancas e Roriz' },
    { designacao: 'Vale de Anta' },
    { designacao: 'Vidago (União das freguesias de Vidago, Arcossó, Selhariz e Vilarinho das Paranheiras)' },
    { designacao: 'Vila Verde da Raia' },
    { designacao: 'Vilar de Nantes' },
    { designacao: 'Vilarelho da Raia' },
    { designacao: 'Vilas Boas' },
    { designacao: 'Vilela Seca' },
    { designacao: 'Vilela do Tâmega' },
    { designacao: 'Águas Frias' }
  ],
  'Cinfães': [
    { designacao: 'Cinfães' },
    { designacao: 'Espadanedo' },
    { designacao: 'Ferreiros de Tendais' },
    { designacao: 'Fornelos' },
    { designacao: 'Moimenta' },
    { designacao: 'Nespereira' },
    { designacao: 'Oliveira do Douro' },
    { designacao: 'Santiago de Piães' },
    { designacao: 'Souselo' },
    { designacao: 'São Cristóvão de Nogueira' },
    { designacao: 'Tarouquela' },
    { designacao: 'Tendais' },
    { designacao: 'Travanca' },
    { designacao: 'União das freguesias de Alhões, Bustelo, Gralheira e Ramires' }
  ],
  'Coimbra': [
    { designacao: 'Almalaguês' },
    { designacao: 'Brasfemes' },
    { designacao: 'Ceira' },
    { designacao: 'Cernache' },
    { designacao: 'Miranda do Corvo' },
    { designacao: 'Santo António dos Olivais' },
    { designacao: 'São João do Campo' },
    { designacao: 'São Silvestre' },
    { designacao: 'Torres do Mondego' },
    { designacao: 'União das freguesias de Antuzede e Vil de Matos' },
    { designacao: 'União das freguesias de Assafarge e Antanhol' },
    { designacao: 'União das freguesias de Coimbra (Sé Nova, Santa Cruz, Almedina e São Bartolomeu)' },
    { designacao: 'União das freguesias de Eiras e São Paulo de Frades' },
    { designacao: 'União das freguesias de Santa Clara e Castelo Viegas' },
    { designacao: 'União das freguesias de Souselas e Botão' },
    { designacao: 'União das freguesias de São Martinho de Árvore e Lamarosa' },
    { designacao: 'União das freguesias de São Martinho do Bispo e Ribeira de Frades' },
    { designacao: 'União das freguesias de Taveiro, Ameal e Arzila' },
    { designacao: 'União das freguesias de Trouxemil e Torre de Vilela' }
  ],
  'Condeixa-a-Nova': [
    { designacao: 'Anobra' },
    { designacao: 'Ega' },
    { designacao: 'Furadouro' },
    { designacao: 'União das freguesias de Condeixa-a-Velha e Condeixa-a-Nova' },
    { designacao: 'União das freguesias de Sebal e Belide' },
    { designacao: 'União das freguesias de Vila Seca e Bem da Fé' },
    { designacao: 'Zambujal' }
  ],
  'Constância': [
    { designacao: 'Constância' },
    { designacao: 'Montalvo' },
    { designacao: 'Santa Margarida da Coutada' }
  ],
  'Coruche': [
    { designacao: 'Biscainho' },
    { designacao: 'Branca' },
    { designacao: 'Couço' },
    { designacao: 'Santana do Mato' },
    { designacao: 'São José da Lamarosa' },
    { designacao: 'União das freguesias de Coruche, Fajarda e Erra' }
  ],
  'Corvo': [
    { designacao: 'Corvo' }
  ],
  'Covilhã': [
    { designacao: 'Aldeia de São Francisco de Assis' },
    { designacao: 'Boidobra' },
    { designacao: 'Cortes do Meio' },
    { designacao: 'Dominguizo' },
    { designacao: 'Erada' },
    { designacao: 'Ferro' },
    { designacao: 'Orjais' },
    { designacao: 'Paul' },
    { designacao: 'Peraboa' },
    { designacao: 'Sobral de São Miguel' },
    { designacao: 'São Jorge da Beira' },
    { designacao: 'Tortosendo' },
    { designacao: 'Unhais da Serra' },
    { designacao: 'União das freguesias de Barco e Coutada' },
    { designacao: 'União das freguesias de Cantar-Galo e Vila do Carvalho' },
    { designacao: 'União das freguesias de Casegas e Ourondo' },
    { designacao: 'União das freguesias de Covilhã e Canhoso' },
    { designacao: 'União das freguesias de Peso e Vales do Rio' },
    { designacao: 'União das freguesias de Teixoso e Sarzedo' },
    { designacao: 'União das freguesias de Vale Formoso e Aldeia do Souto' },
    { designacao: 'Verdelhos' }
  ],
  'Crato': [
    { designacao: 'Aldeia da Mata' },
    { designacao: 'Gáfete' },
    { designacao: 'Monte da Pedra' },
    { designacao: 'União das freguesias de Crato e Mártires, Flor da Rosa e Vale do Peso' }
  ],
  'Cuba': [
    { designacao: 'Cuba' },
    { designacao: 'Faro do Alentejo' },
    { designacao: 'Vila Alva' },
    { designacao: 'Vila Ruiva' }
  ],
  'Câmara de Lobos': [
    { designacao: 'Curral das Freiras' },
    { designacao: 'Câmara de Lobos' },
    { designacao: 'Estreito de Câmara de Lobos' },
    { designacao: 'Jardim da Serra' },
    { designacao: 'Quinta Grande' }
  ],
  'Elvas': [
    { designacao: 'Assunção, Ajuda, Salvador e Santo Ildefonso' },
    { designacao: 'Caia, São Pedro e Alcáçova' },
    { designacao: 'Santa Eulália' },
    { designacao: 'São Brás e São Lourenço' },
    { designacao: 'São Vicente e Ventosa' },
    { designacao: 'União das freguesias de Barbacena e Vila Fernando' },
    { designacao: 'União das freguesias de Terrugem e Vila Boim' }
  ],
  'Entroncamento': [
    { designacao: 'Nossa Senhora de Fátima' },
    { designacao: 'São João Baptista' },
    { designacao: 'União das freguesias de Marmeleira e Assentiz' }
  ],
  'Espinho': [
    { designacao: 'Espinho' },
    { designacao: 'Paramos' },
    { designacao: 'Silvalde' },
    { designacao: 'União das freguesias de Anta e Guetim' }
  ],
  'Esposende': [
    { designacao: 'Antas' },
    { designacao: 'Forjães' },
    { designacao: 'Gemeses' },
    { designacao: 'União das freguesias de Apúlia e Fão' },
    { designacao: 'União das freguesias de Belinho e Mar' },
    { designacao: 'União das freguesias de Esposende, Marinhas e Gandra' },
    { designacao: 'União das freguesias de Fonte Boa e Rio Tinto' },
    { designacao: 'União das freguesias de Palmeira de Faro e Curvos' },
    { designacao: 'Vila Chã' }
  ],
  'Estarreja': [
    { designacao: 'Avanca' },
    { designacao: 'Pardilhó' },
    { designacao: 'Salreu' },
    { designacao: 'União das freguesias de Beduído e Veiros' },
    { designacao: 'União das freguesias de Canelas e Fermelã' }
  ],
  'Estremoz': [
    { designacao: 'Arcos' },
    { designacao: 'Glória' },
    { designacao: 'São Domingos de Ana Loura' },
    { designacao: 'União das freguesias de Estremoz (Santa Maria e Santo André)' },
    { designacao: 'União das freguesias de São Bento do Cortiço e Santo Estêvão' },
    { designacao: 'União das freguesias de São Lourenço de Mamporcão e São Bento de Ana Loura' },
    { designacao: 'União das freguesias do Ameixial (Santa Vitória e São Bento)' },
    { designacao: 'Veiros' },
    { designacao: 'Évora Monte (Santa Maria)' }
  ],
  'Fafe': [
    { designacao: 'Armil' },
    { designacao: 'Arões (Santa Cristina)' },
    { designacao: 'Arões (São Romão)' },
    { designacao: 'Estorãos' },
    { designacao: 'Fafe' },
    { designacao: 'Fornelos' },
    { designacao: 'Golães' },
    { designacao: 'Medelo' },
    { designacao: 'Passos' },
    { designacao: 'Quinchães' },
    { designacao: 'Regadas' },
    { designacao: 'Revelhe' },
    { designacao: 'Ribeiros' },
    { designacao: 'Silvares (São Martinho)' },
    { designacao: 'São Gens' },
    { designacao: 'Travassós' },
    { designacao: 'União de freguesias de Aboim, Felgueiras, Gontim e Pedraído' },
    { designacao: 'União de freguesias de Agrela e Serafão' },
    { designacao: 'União de freguesias de Antime e Silvares (São Clemente)' },
    { designacao: 'União de freguesias de Ardegão, Arnozela e Seidões' },
    { designacao: 'União de freguesias de Cepães e Fareja' },
    { designacao: 'União de freguesias de Freitas e Vila Cova' },
    { designacao: 'União de freguesias de Monte e Queimadela' },
    { designacao: 'União de freguesias de Moreira do Rei e Várzea Cova' },
    { designacao: 'Vinhós' }
  ],
  'Faro': [
    { designacao: 'Montenegro' },
    { designacao: 'Santa Bárbara de Nexe' },
    { designacao: 'União das freguesias de Conceição e Estoi' },
    { designacao: 'União das freguesias de Faro (Sé e São Pedro)' }
  ],
  'Felgueiras': [
    { designacao: 'Airães' },
    { designacao: 'Aião' },
    { designacao: 'Friande' },
    { designacao: 'Idães' },
    { designacao: 'Jugueiros' },
    { designacao: 'Penacova' },
    { designacao: 'Pinheiro' },
    { designacao: 'Pombeiro de Ribavizela' },
    { designacao: 'Refontoura' },
    { designacao: 'Regilde' },
    { designacao: 'Revinhade' },
    { designacao: 'Sendim' },
    { designacao: 'União das freguesias de Macieira da Lixa e Caramos' },
    { designacao: 'União das freguesias de Margaride (Santa Eulália), Várzea, Lagares, Varziela e Moure' },
    { designacao: 'União das freguesias de Pedreira, Rande e Sernande' },
    { designacao: 'União das freguesias de Torrados e Sousa' },
    { designacao: 'União das freguesias de Unhão e Lordelo' },
    { designacao: 'União das freguesias de Vila Cova da Lixa e Borba de Godim' },
    { designacao: 'União das freguesias de Vila Fria e Vizela (São Jorge)' },
    { designacao: 'União das freguesias de Vila Verde e Santão' }
  ],
  'Ferreira do Alentejo': [
    { designacao: 'Figueira dos Cavaleiros' },
    { designacao: 'Odivelas' },
    { designacao: 'União das freguesias de Alfundão e Peroguarda' },
    { designacao: 'União das freguesias de Ferreira do Alentejo e Canhestros' }
  ],
  'Ferreira do Zêzere': [
    { designacao: 'Beco' },
    { designacao: 'Chãos' },
    { designacao: 'Ferreira do Zêzere' },
    { designacao: 'Igreja Nova do Sobral' },
    { designacao: 'Nossa Senhora do Pranto' },
    { designacao: 'União das freguesias de Areias e Pias' },
    { designacao: 'Águas Belas' }
  ],
  'Figueira da Foz': [
    { designacao: 'Alhadas' },
    { designacao: 'Alqueidão' },
    { designacao: 'Bom Sucesso' },
    { designacao: 'Buarcos' },
    { designacao: 'Ferreira-a-Nova' },
    { designacao: 'Lavos' },
    { designacao: 'Maiorca' },
    { designacao: 'Marinha das Ondas' },
    { designacao: 'Moinhos da Gândara' },
    { designacao: 'Paião' },
    { designacao: 'Pelariga' },
    { designacao: 'Quiaios' },
    { designacao: 'São Pedro' },
    { designacao: 'Tavarede' },
    { designacao: 'Vila Verde' }
  ],
  'Figueira de Castelo Rodrigo': [
    { designacao: 'Castelo Rodrigo' },
    { designacao: 'Escalhão' },
    { designacao: 'Figueira de Castelo Rodrigo' },
    { designacao: 'Mata de Lobos' },
    { designacao: 'União das freguesias de Algodres, Vale de Afonsinho e Vilar de Amargo' },
    { designacao: 'União das freguesias de Almofala e Escarigo' },
    { designacao: 'União das freguesias de Cinco Vilas e Reigada' },
    { designacao: 'União das freguesias de Freixeda do Torrão, Quintã de Pêro Martins e Penha de Águia' },
    { designacao: 'União das freguesias do Colmeal e Vilar Torpim' },
    { designacao: 'Vermiosa' }
  ],
  'Figueiró dos Vinhos': [
    { designacao: 'Aguda' },
    { designacao: 'Arega' },
    { designacao: 'Campelo' },
    { designacao: 'União das freguesias de Figueiró dos Vinhos e Bairradas' }
  ],
  'Fornos de Algodres': [
    { designacao: 'Algodres' },
    { designacao: 'Casal Vasco' },
    { designacao: 'Figueiró da Granja' },
    { designacao: 'Fornos de Algodres' },
    { designacao: 'Infias' },
    { designacao: 'Maceira' },
    { designacao: 'Matança' },
    { designacao: 'Muxagata' },
    { designacao: 'Queiriz' },
    { designacao: 'União das freguesias de Cortiçô e Vila Chã' },
    { designacao: 'União das freguesias de Juncais, Vila Ruiva e Vila Soeiro do Chão' },
    { designacao: 'União das freguesias de Sobral Pichorro e Fuinhas' }
  ],
  'Freixo de Espada à Cinta': [
    { designacao: 'Ligares' },
    { designacao: 'Poiares' },
    { designacao: 'União das freguesias de Freixo de Espada à Cinta e Mazouco' },
    { designacao: 'União das freguesias de Lagoaça e Fornos' }
  ],
  'Fronteira': [
    { designacao: 'Cabeço de Vide' },
    { designacao: 'Fronteira' },
    { designacao: 'São Saturnino' }
  ],
  'Funchal': [
    { designacao: 'Funchal (Santa Luzia)' },
    { designacao: 'Funchal (Santa Maria Maior)' },
    { designacao: 'Funchal (São Pedro)' },
    { designacao: 'Funchal (Sé)' },
    { designacao: 'Imaculado Coração de Maria' },
    { designacao: 'Monte' },
    { designacao: 'Santo António' },
    { designacao: 'São Gonçalo' },
    { designacao: 'São Martinho' },
    { designacao: 'São Roque' }
  ],
  'Fundão': [
    { designacao: 'Alcaide' },
    { designacao: 'Alcaria' },
    { designacao: 'Alcongosta' },
    { designacao: 'Alpedrinha' },
    { designacao: 'Barroca' },
    { designacao: 'Bogas de Cima' },
    { designacao: 'Capinha' },
    { designacao: 'Castelejo' },
    { designacao: 'Castelo Novo' },
    { designacao: 'Enxames' },
    { designacao: 'Fatela' },
    { designacao: 'Lavacolhos' },
    { designacao: 'Orca' },
    { designacao: 'Pêro Viseu' },
    { designacao: 'Silvares' },
    { designacao: 'Soalheira' },
    { designacao: 'Souto da Casa' },
    { designacao: 'Telhado' },
    { designacao: 'Três Povos' },
    { designacao: 'União das freguesias de Fundão, Valverde, Donas, Aldeia de Joanes e Aldeia Nova do Cabo' },
    { designacao: 'União das freguesias de Janeiro de Cima e Bogas de Baixo' },
    { designacao: 'União das freguesias de Póvoa de Atalaia e Atalaia do Campo' },
    { designacao: 'União das freguesias de Vale de Prazeres e Mata da Rainha' }
  ],
  'Gavião': [
    { designacao: 'Belver' },
    { designacao: 'Comenda' },
    { designacao: 'Margem' },
    { designacao: 'União das freguesias de Gavião e Atalaia' }
  ],
  'Golegã': [
    { designacao: 'Azinhaga' },
    { designacao: 'Golegã' },
    { designacao: 'Pombalinho' }
  ],
  'Gondomar': [
    { designacao: 'Baguim do Monte (Rio Tinto)' },
    { designacao: 'Lomba' },
    { designacao: 'Rio Tinto' },
    { designacao: 'União das freguesias de Foz do Sousa e Covelo' },
    { designacao: 'União das freguesias de Fânzeres e São Pedro da Cova' },
    { designacao: 'União das freguesias de Gondomar (São Cosme), Valbom e Jovim' },
    { designacao: 'União das freguesias de Melres e Medas' }
  ],
  'Gouveia': [
    { designacao: 'Arcozelo' },
    { designacao: 'Cativelos' },
    { designacao: 'Folgosinho' },
    { designacao: 'Nespereira' },
    { designacao: 'Paços da Serra' },
    { designacao: 'Ribamondego' },
    { designacao: 'São Paio' },
    { designacao: 'União das freguesias de Aldeias e Mangualde da Serra' },
    { designacao: 'União das freguesias de Figueiró da Serra e Freixo da Serra' },
    { designacao: 'União das freguesias de Gouveia (São Pedro e São Julião)' },
    { designacao: 'União das freguesias de Melo e Nabais' },
    { designacao: 'União das freguesias de Moimenta da Serra e Vinhó' },
    { designacao: 'União das freguesias de Rio Torto e Lagarinhos' },
    { designacao: 'Vila Cortês da Serra' },
    { designacao: 'Vila Franca da Serra' },
    { designacao: 'Vila Nova de Tazem' }
  ],
  'Grândola': [
    { designacao: 'Azinheira dos Barros e São Mamede do Sádão' },
    { designacao: 'Carvalhal' },
    { designacao: 'Melides' },
    { designacao: 'União das freguesias de Grândola e Santa Margarida da Serra' }
  ],
  'Guarda': [
    { designacao: 'Adão' },
    { designacao: 'Aldeia Viçosa' },
    { designacao: 'Aldeia do Bispo' },
    { designacao: 'Alvendre' },
    { designacao: 'Arrifana' },
    { designacao: 'Avelãs da Ribeira' },
    { designacao: 'Benespera' },
    { designacao: 'Casal de Cinza' },
    { designacao: 'Castanheira' },
    { designacao: 'Cavadoude' },
    { designacao: 'Codesseiro' },
    { designacao: 'Faia' },
    { designacao: 'Famalicão' },
    { designacao: 'Fernão Joanes' },
    { designacao: 'Gonçalo' },
    { designacao: 'Gonçalo Bocas' },
    { designacao: 'Guarda' },
    { designacao: 'Jarmelo São Miguel' },
    { designacao: 'Jarmelo São Pedro' },
    { designacao: 'João Antão' },
    { designacao: 'Marmeleiro' },
    { designacao: 'Maçainhas' },
    { designacao: 'Meios' },
    { designacao: 'Panoias de Cima' },
    { designacao: 'Pega' },
    { designacao: 'Porto da Carne' },
    { designacao: 'Pêra do Moço' },
    { designacao: 'Ramela' },
    { designacao: 'Santana da Azinha' },
    { designacao: 'Sobral da Serra' },
    { designacao: 'União de freguesias de Avelãs de Ambom e Rocamondo' },
    { designacao: 'União de freguesias de Corujeira e Trinta' },
    { designacao: 'União de freguesias de Mizarela, Pêro Soares e Vila Soeiro' },
    { designacao: 'União de freguesias de Pousade e Albardo' },
    { designacao: 'União de freguesias de Rochoso e Monte Margarida' },
    { designacao: 'Vale de Estrela' },
    { designacao: 'Valhelhas' },
    { designacao: 'Vela' },
    { designacao: 'Videmonte' },
    { designacao: 'Vila Cortês do Mondego' },
    { designacao: 'Vila Fernando' },
    { designacao: 'Vila Franca do Deão' },
    { designacao: 'Vila Garcia' }
  ],
  'Guimarães': [
    { designacao: 'Aldão' },
    { designacao: 'Azurém' },
    { designacao: 'Barco' },
    { designacao: 'Brito' },
    { designacao: 'Caldelas' },
    { designacao: 'Candoso (São Martinho)' },
    { designacao: 'Costa' },
    { designacao: 'Creixomil' },
    { designacao: 'Fermentões' },
    { designacao: 'Gondar' },
    { designacao: 'Gonça' },
    { designacao: 'Guardizela' },
    { designacao: 'Infantas' },
    { designacao: 'Longos' },
    { designacao: 'Lordelo' },
    { designacao: 'Mesão Frio' },
    { designacao: 'Moreira de Cónegos' },
    { designacao: 'Nespereira' },
    { designacao: 'Pedome' },
    { designacao: 'Pencelo' },
    { designacao: 'Pinheiro' },
    { designacao: 'Polvoreira' },
    { designacao: 'Ponte' },
    { designacao: 'Prazins (Santa Eufémia)' },
    { designacao: 'Ronfe' },
    { designacao: 'Sande (São Martinho)' },
    { designacao: 'Selho (São Cristóvão)' },
    { designacao: 'Serzedelo' },
    { designacao: 'Silvares' },
    { designacao: 'São Torcato' },
    { designacao: 'União das freguesias de Abação e Gémeos' },
    { designacao: 'União das freguesias de Airão Santa Maria, Airão São João e Vermil' },
    { designacao: 'União das freguesias de Arosa e Castelões' },
    { designacao: 'União das freguesias de Atães e Rendufe' },
    { designacao: 'União das freguesias de Briteiros Santo Estêvão e Donim' },
    { designacao: 'União das freguesias de Candoso São Tiago e Mascotelos' },
    { designacao: 'União das freguesias de Conde e Gandarela' },
    { designacao: 'União das freguesias de Leitões, Oleiros e Figueiredo' },
    { designacao: 'União das freguesias de Oliveira, São Paio e São Sebastião' },
    { designacao: 'União das freguesias de Prazins Santo Tirso e Corvite' },
    { designacao: 'União das freguesias de Sande São Lourenço e Balazar' },
    { designacao: 'União das freguesias de Selho São Lourenço e Gominhães' },
    { designacao: 'União das freguesias de Serzedo e Calvos' },
    { designacao: 'União das freguesias de Souto Santa Maria, Souto São Salvador e Gondomar' },
    { designacao: 'União das freguesias de Tabuadelo e São Faustino' },
    { designacao: 'União das freguesias de Tagilde e Vizela (São Paio)' },
    { designacao: 'Urgezes' }
  ],
  'Góis': [
    { designacao: 'Alvares' },
    { designacao: 'Cabril' },
    { designacao: 'Góis' },
    { designacao: 'União das freguesias de Cadafaz e Colmeal' },
    { designacao: 'Vila Nova do Ceira' }
  ],
  'Horta': [
    { designacao: 'Capelo' },
    { designacao: 'Castelo Branco' },
    { designacao: 'Cedros' },
    { designacao: 'Feteira' },
    { designacao: 'Flamengos' },
    { designacao: 'Horta (Angústias)' },
    { designacao: 'Horta (Matriz)' },
    { designacao: 'Pedro Miguel' },
    { designacao: 'Praia do Almoxarife' },
    { designacao: 'Praia do Norte' },
    { designacao: 'Ribeirinha' },
    { designacao: 'Salão' }
  ],
  'Idanha-a-Nova': [
    { designacao: 'Aldeia de Santa Margarida' },
    { designacao: 'Ladoeiro' },
    { designacao: 'Medelim' },
    { designacao: 'Oledo' },
    { designacao: 'Penha Garcia' },
    { designacao: 'Proença-a-Velha' },
    { designacao: 'Rosmaninhal' },
    { designacao: 'São Miguel de Acha' },
    { designacao: 'Toulões' },
    { designacao: 'União das freguesias de Idanha-a-Nova e Alcafozes' },
    { designacao: 'União das freguesias de Monfortinho e Salvaterra do Extremo' },
    { designacao: 'União das freguesias de Monsanto e Idanha-a-Velha' },
    { designacao: 'União das freguesias de Zebreira e Segura' }
  ],
  'Lagoa': [
    { designacao: 'Cabouco' },
    { designacao: 'Ferragudo' },
    { designacao: 'Lagoa (Nossa Senhora do Rosário)' },
    { designacao: 'Lagoa (Santa Cruz)' },
    { designacao: 'Porches' },
    { designacao: 'Ribeira Chã' },
    { designacao: 'União das freguesias de Estômbar e Parchal' },
    { designacao: 'União das freguesias de Lagoa e Carvoeiro' },
    { designacao: 'Água de Pau' }
  ],
  'Lagos': [
    { designacao: 'Luz' },
    { designacao: 'Odiáxere' },
    { designacao: 'União das freguesias de Bensafrim e Barão de São João' },
    { designacao: 'União das freguesias de Lagos (São Sebastião e Santa Maria)' }
  ],
  'Lajes das Flores': [
    { designacao: 'Fajã Grande' },
    { designacao: 'Fajãzinha' },
    { designacao: 'Fazenda' },
    { designacao: 'Lajedo' },
    { designacao: 'Lajes das Flores' },
    { designacao: 'Lomba' },
    { designacao: 'Mosteiro' }
  ],
  'Lajes do Pico': [
    { designacao: 'Calheta de Nesquim' },
    { designacao: 'Lajes do Pico' },
    { designacao: 'Piedade' },
    { designacao: 'Ribeiras' },
    { designacao: 'Ribeirinha' },
    { designacao: 'São João' }
  ],
  'Lamego': [
    { designacao: 'Avões' },
    { designacao: 'Britiande' },
    { designacao: 'Cambres' },
    { designacao: 'Ferreirim' },
    { designacao: 'Ferreiros de Avões' },
    { designacao: 'Figueira' },
    { designacao: 'Lalim' },
    { designacao: 'Lamego (Almacave e Sé)' },
    { designacao: 'Lazarim' },
    { designacao: 'Penajóia' },
    { designacao: 'Penude' },
    { designacao: 'Samodães' },
    { designacao: 'Sande' },
    { designacao: 'União das freguesias de Bigorne, Magueija e Pretarouca' },
    { designacao: 'União das freguesias de Cepões, Meijinhos e Melcões' },
    { designacao: 'União das freguesias de Parada do Bispo e Valdigem' },
    { designacao: 'Vila Nova de Souto d\'El-Rei' },
    { designacao: 'Várzea de Abrunhais' }
  ],
  'Leiria': [
    { designacao: 'Amor' },
    { designacao: 'Arrabal' },
    { designacao: 'Bajouca' },
    { designacao: 'Bidoeira de Cima' },
    { designacao: 'Caranguejeira' },
    { designacao: 'Coimbrão' },
    { designacao: 'Maceira' },
    { designacao: 'Milagres' },
    { designacao: 'Regueira de Pontes' },
    { designacao: 'União das freguesias de Colmeias e Memória' },
    { designacao: 'União das freguesias de Leiria, Pousos, Barreira e Cortes' },
    { designacao: 'União das freguesias de Marrazes e Barosa' },
    { designacao: 'União das freguesias de Monte Real e Carvide' },
    { designacao: 'União das freguesias de Monte Redondo e Carreira' },
    { designacao: 'União das freguesias de Parceiros e Azoia' },
    { designacao: 'União das freguesias de Santa Catarina da Serra e Chainça' },
    { designacao: 'União das freguesias de Santa Eufémia e Boa Vista' },
    { designacao: 'União das freguesias de Souto da Carpalhosa e Ortigosa' }
  ],
  'Lisboa': [
    { designacao: 'Ajuda' },
    { designacao: 'Alcântara' },
    { designacao: 'Alvalade' },
    { designacao: 'Areeiro' },
    { designacao: 'Arroios' },
    { designacao: 'Avenidas Novas' },
    { designacao: 'Beato' },
    { designacao: 'Belém' },
    { designacao: 'Benfica' },
    { designacao: 'Campo de Ourique' },
    { designacao: 'Campolide' },
    { designacao: 'Carnide' },
    { designacao: 'Estrela' },
    { designacao: 'Lumiar' },
    { designacao: 'Marvila' },
    { designacao: 'Misericórdia' },
    { designacao: 'Olivais' },
    { designacao: 'Parque das Nações' },
    { designacao: 'Penha de França' },
    { designacao: 'Santa Clara' },
    { designacao: 'Santa Maria Maior' },
    { designacao: 'Santo António' },
    { designacao: 'São Domingos de Benfica' },
    { designacao: 'São Vicente' }
  ],
  'Loulé': [
    { designacao: 'Almancil' },
    { designacao: 'Alte' },
    { designacao: 'Ameixial' },
    { designacao: 'Boliqueime' },
    { designacao: 'Loulé (São Clemente)' },
    { designacao: 'Loulé (São Sebastião)' },
    { designacao: 'Quarteira' },
    { designacao: 'Salir' },
    { designacao: 'União de freguesias de Querença, Tôr e Benafim' }
  ],
  'Loures': [
    { designacao: 'Bucelas' },
    { designacao: 'Fanhões' },
    { designacao: 'Loures' },
    { designacao: 'Lousa' },
    { designacao: 'União das freguesias de Camarate, Unhos e Apelação' },
    { designacao: 'União das freguesias de Moscavide e Portela' },
    { designacao: 'União das freguesias de Sacavém e Prior Velho' },
    { designacao: 'União das freguesias de Santa Iria de Azoia, São João da Talha e Bobadela' },
    { designacao: 'União das freguesias de Santo Antão e São Julião do Tojal' },
    { designacao: 'União das freguesias de Santo António dos Cavaleiros e Frielas' }
  ],
  'Lourinhã': [
    { designacao: 'Moita dos Ferreiros' },
    { designacao: 'Reguengo Grande' },
    { designacao: 'Ribamar' },
    { designacao: 'Santa Bárbara' },
    { designacao: 'União das freguesias de Lourinhã e Atalaia' },
    { designacao: 'União das freguesias de Maxial e Monte Redondo' },
    { designacao: 'União das freguesias de Miragaia e Marteleira' },
    { designacao: 'União das freguesias de São Bartolomeu dos Galegos e Moledo' },
    { designacao: 'Vimeiro' }
  ],
  'Lousada': [
    { designacao: 'Aveleda' },
    { designacao: 'Caíde de Rei' },
    { designacao: 'Lodares' },
    { designacao: 'Macieira' },
    { designacao: 'Meinedo' },
    { designacao: 'Nevogilde' },
    { designacao: 'Sousela' },
    { designacao: 'Torno' },
    { designacao: 'União das freguesias de Cernadelo e Lousada (São Miguel e Santa Margarida)' },
    { designacao: 'União das freguesias de Cristelos, Boim e Ordem' },
    { designacao: 'União das freguesias de Figueiras e Covas' },
    { designacao: 'União das freguesias de Lustosa e Barrosas (Santo Estêvão)' },
    { designacao: 'União das freguesias de Margaride (Santa Eulália), Várzea, Lagares, Varziela e Moure' },
    { designacao: 'União das freguesias de Nespereira e Casais' },
    { designacao: 'União das freguesias de Silvares, Pias, Nogueira e Alvarenga' },
    { designacao: 'Vilar do Torno e Alentém' }
  ],
  'Lousã': [
    { designacao: 'Gândaras' },
    { designacao: 'Lavegadas' },
    { designacao: 'Poiares (Santo André)' },
    { designacao: 'Serpins' },
    { designacao: 'São Miguel de Poiares' },
    { designacao: 'União das freguesias de Foz de Arouce e Casal de Ermio' },
    { designacao: 'União das freguesias de Lousã e Vilarinho' }
  ],
  'Macedo de Cavaleiros': [
    { designacao: 'Amendoeira' },
    { designacao: 'Arcas' },
    { designacao: 'Carrapatas' },
    { designacao: 'Chacim' },
    { designacao: 'Cortiços' },
    { designacao: 'Corujas' },
    { designacao: 'Ferreira' },
    { designacao: 'Grijó' },
    { designacao: 'Lagoa' },
    { designacao: 'Lamalonga' },
    { designacao: 'Lamas' },
    { designacao: 'Lombo' },
    { designacao: 'Macedo de Cavaleiros' },
    { designacao: 'Morais' },
    { designacao: 'Olmos' },
    { designacao: 'Peredo' },
    { designacao: 'Salselas' },
    { designacao: 'Sezulfe' },
    { designacao: 'Talhas' },
    { designacao: 'União das freguesias de Ala e Vilarinho do Monte' },
    { designacao: 'União das freguesias de Bornes e Burga' },
    { designacao: 'União das freguesias de Castelãos e Vilar do Monte' },
    { designacao: 'União das freguesias de Espadanedo, Edroso, Murçós e Soutelo Mourisco' },
    { designacao: 'União das freguesias de Podence e Santa Combinha' },
    { designacao: 'União das freguesias de Talhinhas e Bagueixe' },
    { designacao: 'Vale Benfeito' },
    { designacao: 'Vale da Porca' },
    { designacao: 'Vale de Prados' },
    { designacao: 'Vilarinho de Agrochão' },
    { designacao: 'Vinhas' }
  ],
  'Machico': [
    { designacao: 'Caniçal' },
    { designacao: 'Machico' },
    { designacao: 'Porto da Cruz' },
    { designacao: 'Santo António da Serra' },
    { designacao: 'Água de Pena' }
  ],
  'Madalena': [
    { designacao: 'Bandeiras' },
    { designacao: 'Candelária' },
    { designacao: 'Criação Velha' },
    { designacao: 'Madalena' },
    { designacao: 'São Caetano' },
    { designacao: 'São Mateus' }
  ],
  'Mafra': [
    { designacao: 'Carvoeira' },
    { designacao: 'Encarnação' },
    { designacao: 'Ericeira' },
    { designacao: 'Mafra' },
    { designacao: 'Milharado' },
    { designacao: 'Santo Isidoro' },
    { designacao: 'União das freguesias de Azueira e Sobral da Abelheira' },
    { designacao: 'União das freguesias de Enxara do Bispo, Gradil e Vila Franca do Rosário' },
    { designacao: 'União das freguesias de Igreja Nova e Cheleiros' },
    { designacao: 'União das freguesias de Malveira e São Miguel de Alcainça' },
    { designacao: 'União das freguesias de Venda do Pinheiro e Santo Estêvão das Galés' }
  ],
  'Maia': [
    { designacao: 'Castêlo da Maia' },
    { designacao: 'Cidade da Maia' },
    { designacao: 'Folgosa' },
    { designacao: 'Milheirós' },
    { designacao: 'Moreira' },
    { designacao: 'Nogueira e Silva Escura' },
    { designacao: 'Pedrouços' },
    { designacao: 'São Pedro Fins' },
    { designacao: 'Vila Nova da Telha' },
    { designacao: 'Águas Santas' }
  ],
  'Mangualde': [
    { designacao: 'Abrunhosa-a-Velha' },
    { designacao: 'Alcafache' },
    { designacao: 'Cunha Baixa' },
    { designacao: 'Espinho' },
    { designacao: 'Fornos de Maceira Dão' },
    { designacao: 'Freixiosa' },
    { designacao: 'Quintela de Azurara' },
    { designacao: 'São João da Fresta' },
    { designacao: 'União das freguesias de Mangualde, Mesquitela e Cunha Alta' },
    { designacao: 'União das freguesias de Moimenta de Maceira Dão e Lobelhe do Mato' },
    { designacao: 'União das freguesias de Santiago de Cassurrães e Póvoa de Cervães' },
    { designacao: 'União das freguesias de Tavares (Chãs, Várzea e Travanca)' }
  ],
  'Manteigas': [
    { designacao: 'Manteigas (Santa Maria)' },
    { designacao: 'Manteigas (São Pedro)' },
    { designacao: 'Sameiro' },
    { designacao: 'Vale de Amoreira' }
  ],
  'Marco de Canaveses': [
    { designacao: 'Alpendorada, Várzea e Torrão' },
    { designacao: 'Avessadas e Rosém' },
    { designacao: 'Banho e Carvalhosa' },
    { designacao: 'Bem Viver' },
    { designacao: 'Constance' },
    { designacao: 'Livração' },
    { designacao: 'Marco' },
    { designacao: 'Paredes de Viadores e Manhuncelos' },
    { designacao: 'Penhalonga e Paços de Gaiolo' },
    { designacao: 'Sande e São Lourenço' },
    { designacao: 'Soalhães' },
    { designacao: 'Sobretâmega' },
    { designacao: 'Tabuado' },
    { designacao: 'Vila Boa de Quires e Maureles' },
    { designacao: 'Vila Boa do Bispo' },
    { designacao: 'Várzea, Aliviada e Folhada' }
  ],
  'Marinha Grande': [
    { designacao: 'Marinha Grande' },
    { designacao: 'Moita' },
    { designacao: 'Vieira de Leiria' }
  ],
  'Marvão': [
    { designacao: 'Beirã' },
    { designacao: 'Santa Maria de Marvão' },
    { designacao: 'Santo António das Areias' },
    { designacao: 'São Salvador da Aramenha' }
  ],
  'Matosinhos': [
    { designacao: 'União das freguesias de Custóias, Leça do Balio e Guifões' },
    { designacao: 'União das freguesias de Matosinhos e Leça da Palmeira' },
    { designacao: 'União das freguesias de Perafita, Lavra e Santa Cruz do Bispo' },
    { designacao: 'União das freguesias de São Mamede de Infesta e Senhora da Hora' }
  ],
  'Mação': [
    { designacao: 'Amêndoa' },
    { designacao: 'Cardigos' },
    { designacao: 'Carvoeiro' },
    { designacao: 'Envendos' },
    { designacao: 'Ortiga' },
    { designacao: 'União das freguesias de Mação, Penhascoso e Aboboreira' }
  ],
  'Mealhada': [
    { designacao: 'Barcouço' },
    { designacao: 'Casal Comba' },
    { designacao: 'Luso' },
    { designacao: 'Pampilhosa' },
    { designacao: 'União das freguesias da Mealhada, Ventosa do Bairro e Antes' },
    { designacao: 'União das freguesias de Souselas e Botão' },
    { designacao: 'Vacariça' }
  ],
  'Meda': [
    { designacao: 'Aveloso' },
    { designacao: 'Barreira' },
    { designacao: 'Coriscada' },
    { designacao: 'Longroiva' },
    { designacao: 'Marialva' },
    { designacao: 'Poço do Canto' },
    { designacao: 'Rabaçal' },
    { designacao: 'Ranhados' },
    { designacao: 'União das freguesias de Mêda, Outeiro de Gatos e Fonte Longa' },
    { designacao: 'União das freguesias de Prova e Casteição' },
    { designacao: 'União das freguesias de Vale Flor, Carvalhal e Pai Penela' }
  ],
  'Melgaço': [
    { designacao: 'Alvaredo' },
    { designacao: 'Cousso' },
    { designacao: 'Cristoval' },
    { designacao: 'Fiães' },
    { designacao: 'Gave' },
    { designacao: 'Paderne' },
    { designacao: 'Penso' },
    { designacao: 'São Paio' },
    { designacao: 'União das freguesias de Castro Laboreiro e Lamas de Mouro' },
    { designacao: 'União das freguesias de Chaviães e Paços' },
    { designacao: 'União das freguesias de Parada do Monte e Cubalhão' },
    { designacao: 'União das freguesias de Prado e Remoães' },
    { designacao: 'União das freguesias de Vila e Roussas' }
  ],
  'Mesão Frio': [
    { designacao: 'Barqueiros' },
    { designacao: 'Cidadelhe' },
    { designacao: 'Mesão Frio (Santo André)' },
    { designacao: 'Oliveira' },
    { designacao: 'Vila Marim' }
  ],
  'Mira': [
    { designacao: 'Carapelhos' },
    { designacao: 'Mira' },
    { designacao: 'Praia de Mira' },
    { designacao: 'Seixo' }
  ],
  'Miranda do Corvo': [
    { designacao: 'Lamas' },
    { designacao: 'Miranda do Corvo' },
    { designacao: 'União das freguesias de Semide e Rio Vide' },
    { designacao: 'Vila Nova' }
  ],
  'Miranda do Douro': [
    { designacao: 'Duas Igrejas' },
    { designacao: 'Genísio' },
    { designacao: 'Malhadas' },
    { designacao: 'Miranda do Douro' },
    { designacao: 'Palaçoulo' },
    { designacao: 'Picote' },
    { designacao: 'Póvoa' },
    { designacao: 'São Martinho de Angueira' },
    { designacao: 'União das freguesias de Constantim e Cicouro' },
    { designacao: 'União das freguesias de Ifanes e Paradela' },
    { designacao: 'União das freguesias de Sendim e Atenor' },
    { designacao: 'União das freguesias de Silva e Águas Vivas' },
    { designacao: 'Vila Chã de Braciosa' }
  ],
  'Mirandela': [
    { designacao: 'Abambres' },
    { designacao: 'Abreiro' },
    { designacao: 'Aguieiras' },
    { designacao: 'Alvites' },
    { designacao: 'Bouça' },
    { designacao: 'Cabanelas' },
    { designacao: 'Caravelas' },
    { designacao: 'Carvalhais' },
    { designacao: 'Cedães' },
    { designacao: 'Cobro' },
    { designacao: 'Fradizela' },
    { designacao: 'Frechas' },
    { designacao: 'Lamas de Orelhão' },
    { designacao: 'Mascarenhas' },
    { designacao: 'Mirandela' },
    { designacao: 'Múrias' },
    { designacao: 'Passos' },
    { designacao: 'Suçães' },
    { designacao: 'São Pedro Velho' },
    { designacao: 'São Salvador' },
    { designacao: 'Torre de Dona Chama' },
    { designacao: 'União das freguesias de Avantos e Romeu' },
    { designacao: 'União das freguesias de Avidagos, Navalho e Pereira' },
    { designacao: 'União das freguesias de Barcel, Marmelos e Valverde da Gestosa' },
    { designacao: 'União das freguesias de Franco e Vila Boa' },
    { designacao: 'União das freguesias de Freixeda e Vila Verde' },
    { designacao: 'Vale de Asnes' },
    { designacao: 'Vale de Gouvinhas' },
    { designacao: 'Vale de Salgueiro' },
    { designacao: 'Vale de Telhas' }
  ],
  'Mogadouro': [
    { designacao: 'Azinhoso' },
    { designacao: 'Bemposta' },
    { designacao: 'Brunhoso' },
    { designacao: 'Bruçó' },
    { designacao: 'Castelo Branco' },
    { designacao: 'Castro Vicente' },
    { designacao: 'Meirinhos' },
    { designacao: 'Paradela' },
    { designacao: 'Penas Roias' },
    { designacao: 'Peredo da Bemposta' },
    { designacao: 'Saldanha' },
    { designacao: 'São Martinho do Peso' },
    { designacao: 'Travanca' },
    { designacao: 'Tó' },
    { designacao: 'União das freguesias de Brunhozinho, Castanheira e Sanhoane' },
    { designacao: 'União das freguesias de Mogadouro, Valverde, Vale de Porco e Vilar de Rei' },
    { designacao: 'União das freguesias de Remondes e Soutelo' },
    { designacao: 'União das freguesias de Vilarinho dos Galegos e Ventozelo' },
    { designacao: 'Urrós' },
    { designacao: 'Vale da Madre' },
    { designacao: 'Vila de Ala' }
  ],
  'Moimenta da Beira': [
    { designacao: 'Alvite' },
    { designacao: 'Arcozelos' },
    { designacao: 'Baldos' },
    { designacao: 'Cabaços' },
    { designacao: 'Caria' },
    { designacao: 'Castelo' },
    { designacao: 'Leomil' },
    { designacao: 'Moimenta da Beira' },
    { designacao: 'Passô' },
    { designacao: 'Rua' },
    { designacao: 'Sarzedo' },
    { designacao: 'Sever' },
    { designacao: 'União das freguesias de Paradinha e Nagosa' },
    { designacao: 'União das freguesias de Peva e Segões' },
    { designacao: 'União das freguesias de Pêra Velha, Aldeia de Nacomba e Ariz' },
    { designacao: 'Vilar' }
  ],
  'Moita': [
    { designacao: 'Alhos Vedros' },
    { designacao: 'Moita' },
    { designacao: 'União das freguesias de Baixa da Banheira e Vale da Amoreira' },
    { designacao: 'União das freguesias de Gaio-Rosário e Sarilhos Pequenos' }
  ],
  'Monchique': [
    { designacao: 'Alferce' },
    { designacao: 'Marmelete' },
    { designacao: 'Monchique' }
  ],
  'Mondim de Basto': [
    { designacao: 'Atei' },
    { designacao: 'Bilhó' },
    { designacao: 'Mondim de Basto' },
    { designacao: 'União das freguesias de Campanhó e Paradança' },
    { designacao: 'União das freguesias de Ermelo e Pardelhas' },
    { designacao: 'Vilar de Ferreiros' }
  ],
  'Monforte': [
    { designacao: 'Assumar' },
    { designacao: 'Monforte' },
    { designacao: 'Santo Aleixo' },
    { designacao: 'Vaiamonte' }
  ],
  'Montalegre': [
    { designacao: 'Cabril' },
    { designacao: 'Cervos' },
    { designacao: 'Chã' },
    { designacao: 'Covelo do Gerês' },
    { designacao: 'Ferral' },
    { designacao: 'Gralhas' },
    { designacao: 'Morgade' },
    { designacao: 'Negrões' },
    { designacao: 'Outeiro' },
    { designacao: 'Pitões das Junias' },
    { designacao: 'Reigoso' },
    { designacao: 'Salto' },
    { designacao: 'Santo André' },
    { designacao: 'Sarraquinhos' },
    { designacao: 'Solveira' },
    { designacao: 'Tourém' },
    { designacao: 'União das freguesias de Cambeses do Rio, Donões e Mourilhe' },
    { designacao: 'União das freguesias de Meixedo e Padornelos' },
    { designacao: 'União das freguesias de Montalegre e Padroso' },
    { designacao: 'União das freguesias de Paradela, Contim e Fiães' },
    { designacao: 'União das freguesias de Sezelhe e Covelães' },
    { designacao: 'União das freguesias de Venda Nova e Pondras' },
    { designacao: 'União das freguesias de Viade de Baixo e Fervidelas' },
    { designacao: 'União das freguesias de Vilar de Perdizes e Meixide' },
    { designacao: 'Vila da Ponte' }
  ],
  'Montemor-o-Novo': [
    { designacao: 'Cabrela' },
    { designacao: 'Ciborro' },
    { designacao: 'Foros de Vale de Figueira' },
    { designacao: 'Santiago do Escoural' },
    { designacao: 'São Cristóvão' },
    { designacao: 'União das freguesias de Cortiçadas de Lavre e Lavre' },
    { designacao: 'União das freguesias de Nossa Senhora da Vila, Nossa Senhora do Bispo e Silveiras' }
  ],
  'Montemor-o-Velho': [
    { designacao: 'Arazede' },
    { designacao: 'Carapinheira' },
    { designacao: 'Ereira' },
    { designacao: 'Liceia' },
    { designacao: 'Meãs do Campo' },
    { designacao: 'Pereira' },
    { designacao: 'Santo Varão' },
    { designacao: 'Seixo de Gatões' },
    { designacao: 'Tentúgal' },
    { designacao: 'União das freguesias de Abrunheira, Verride e Vila Nova da Barca' },
    { designacao: 'União das freguesias de Montemor-o-Velho e Gatões' }
  ],
  'Montijo': [
    { designacao: 'Canha' },
    { designacao: 'Sarilhos Grandes' },
    { designacao: 'União das freguesias de Atalaia e Alto Estanqueiro-Jardia' },
    { designacao: 'União das freguesias de Montijo e Afonsoeiro' },
    { designacao: 'União das freguesias de Pegões' }
  ],
  'Monção': [
    { designacao: 'Abedim' },
    { designacao: 'Barbeita' },
    { designacao: 'Barroças e Taias' },
    { designacao: 'Bela' },
    { designacao: 'Cambeses' },
    { designacao: 'Lara' },
    { designacao: 'Longos Vales' },
    { designacao: 'Merufe' },
    { designacao: 'Moreira' },
    { designacao: 'Pias' },
    { designacao: 'Pinheiros' },
    { designacao: 'Podame' },
    { designacao: 'Portela' },
    { designacao: 'Riba de Mouro' },
    { designacao: 'Segude' },
    { designacao: 'Tangil' },
    { designacao: 'Trute' },
    { designacao: 'União das freguesias de Anhões e Luzio' },
    { designacao: 'União das freguesias de Ceivães e Badim' },
    { designacao: 'União das freguesias de Mazedo e Cortes' },
    { designacao: 'União das freguesias de Messegães, Valadares e Sá' },
    { designacao: 'União das freguesias de Monção e Troviscoso' },
    { designacao: 'União das freguesias de Sago, Lordelo e Parada' },
    { designacao: 'União das freguesias de Troporiz e Lapela' }
  ],
  'Mora': [
    { designacao: 'Brotas' },
    { designacao: 'Cabeção' },
    { designacao: 'Mora' },
    { designacao: 'Pavia' }
  ],
  'Mortágua': [
    { designacao: 'Cercosa' },
    { designacao: 'Espinho' },
    { designacao: 'Marmeleira' },
    { designacao: 'Pala' },
    { designacao: 'Sobral' },
    { designacao: 'Trezói' },
    { designacao: 'União das freguesias de Mortágua, Vale de Remígio, Cortegaça e Almaça' }
  ],
  'Moura': [
    { designacao: 'Amareleja' },
    { designacao: 'Póvoa de São Miguel' },
    { designacao: 'Sobral da Adiça' },
    { designacao: 'União das freguesias de Moura (Santo Agostinho e São João Baptista) e Santo Amador' },
    { designacao: 'União das freguesias de Safara e Santo Aleixo da Restauração' }
  ],
  'Mourão': [
    { designacao: 'Granja' },
    { designacao: 'Luz' },
    { designacao: 'Mourão' }
  ],
  'Murtosa': [
    { designacao: 'Bunheiro' },
    { designacao: 'Monte' },
    { designacao: 'Murtosa' },
    { designacao: 'Torreira' },
    { designacao: 'União das freguesias de Beduído e Veiros' }
  ],
  'Murça': [
    { designacao: 'Candedo' },
    { designacao: 'Fiolhoso' },
    { designacao: 'Jou' },
    { designacao: 'Murça' },
    { designacao: 'União das freguesias de Carva e Vilares' },
    { designacao: 'União das freguesias de Noura e Palheiros' },
    { designacao: 'Valongo de Milhais' }
  ],
  'Mértola': [
    { designacao: 'Alcaria Ruiva' },
    { designacao: 'Corte do Pinto' },
    { designacao: 'Espírito Santo' },
    { designacao: 'Mértola' },
    { designacao: 'Santana de Cambas' },
    { designacao: 'São João dos Caldeireiros' },
    { designacao: 'União das freguesias de São Miguel do Pinheiro, São Pedro de Solis e São Sebastião dos Carros' }
  ],
  'Nazaré': [
    { designacao: 'Famalicão' },
    { designacao: 'Nazaré' },
    { designacao: 'Valado dos Frades' }
  ],
  'Nelas': [
    { designacao: 'Canas de Senhorim' },
    { designacao: 'Lapa do Lobo' },
    { designacao: 'Nelas' },
    { designacao: 'Senhorim' },
    { designacao: 'União das freguesias de Carvalhal Redondo e Aguieira' },
    { designacao: 'União das freguesias de Santar e Moreira' },
    { designacao: 'Vilar Seco' }
  ],
  'Nisa': [
    { designacao: 'Alpalhão' },
    { designacao: 'Montalvão' },
    { designacao: 'Santana' },
    { designacao: 'São Matias' },
    { designacao: 'Tolosa' },
    { designacao: 'União das freguesias de Arez e Amieira do Tejo' },
    { designacao: 'União das freguesias de Espírito Santo, Nossa Senhora da Graça e São Simão' }
  ],
  'Nordeste': [
    { designacao: 'Achada' },
    { designacao: 'Achadinha' },
    { designacao: 'Algarvia' },
    { designacao: 'Lomba da Fazenda' },
    { designacao: 'Nordeste' },
    { designacao: 'Salga' },
    { designacao: 'Santana' },
    { designacao: 'Santo António de Nordestinho' },
    { designacao: 'São Pedro de Nordestinho' }
  ],
  'Odemira': [
    { designacao: 'Boavista dos Pinheiros' },
    { designacao: 'Colos' },
    { designacao: 'Longueira/Almograve' },
    { designacao: 'Luzianes-Gare' },
    { designacao: 'Relíquias' },
    { designacao: 'Sabóia' },
    { designacao: 'Santa Clara-a-Velha' },
    { designacao: 'São Luís' },
    { designacao: 'São Martinho das Amoreiras' },
    { designacao: 'São Salvador e Santa Maria' },
    { designacao: 'São Teotónio' },
    { designacao: 'Vale de Santiago' },
    { designacao: 'Vila Nova de Milfontes' }
  ],
  'Odivelas': [
    { designacao: 'Odivelas' },
    { designacao: 'União das freguesias de Pontinha e Famões' },
    { designacao: 'União das freguesias de Póvoa de Santo Adrião e Olival Basto' },
    { designacao: 'União das freguesias de Ramada e Caneças' }
  ],
  'Oeiras': [
    { designacao: 'Barcarena' },
    { designacao: 'Porto Salvo' },
    { designacao: 'União das freguesias de Algés, Linda-a-Velha e Cruz Quebrada-Dafundo' },
    { designacao: 'União das freguesias de Carnaxide e Queijas' },
    { designacao: 'União das freguesias de Oeiras e São Julião da Barra, Paço de Arcos e Caxias' }
  ],
  'Oleiros': [
    { designacao: 'Cambas' },
    { designacao: 'Estreito - Vilar Barroco' },
    { designacao: 'Isna' },
    { designacao: 'Madeirã' },
    { designacao: 'Mosteiro' },
    { designacao: 'Oleiros - Amieira' },
    { designacao: 'Orvalho' },
    { designacao: 'Sarnadas de São Simão' },
    { designacao: 'Sobral' },
    { designacao: 'Álvaro' }
  ],
  'Olhão': [
    { designacao: 'Olhão' },
    { designacao: 'Pechão' },
    { designacao: 'Quelfes' },
    { designacao: 'União das freguesias de Moncarapacho e Fuseta' }
  ],
  'Oliveira de Azeméis': [
    { designacao: 'Carregosa' },
    { designacao: 'Cesar' },
    { designacao: 'Fajões' },
    { designacao: 'Loureiro' },
    { designacao: 'Macieira de Sarnes' },
    { designacao: 'Ossela' },
    { designacao: 'São Martinho da Gândara' },
    { designacao: 'São Roque' },
    { designacao: 'União das freguesias de Nogueira do Cravo e Pindelo' },
    { designacao: 'União das freguesias de Oliveira de Azeméis, Santiago de Riba-Ul, Ul, Macinhata da Seixa e Madail' },
    { designacao: 'União das freguesias de Pinheiro da Bemposta, Travanca e Palmaz' },
    { designacao: 'Vila de Cucujães' }
  ],
  'Oliveira de Frades': [
    { designacao: 'Arcozelo das Maias' },
    { designacao: 'Pinheiro' },
    { designacao: 'Ribeiradio' },
    { designacao: 'São João da Serra' },
    { designacao: 'São Vicente de Lafões' },
    { designacao: 'União das freguesias de Arca e Varzielas' },
    { designacao: 'União das freguesias de Destriz e Reigoso' },
    { designacao: 'União das freguesias de Oliveira de Frades, Souto de Lafões e Sejães' }
  ],
  'Oliveira do Bairro': [
    { designacao: 'Oiã' },
    { designacao: 'Oliveira do Bairro' },
    { designacao: 'Palhaça' },
    { designacao: 'União das freguesias de Bustos, Troviscal e Mamarrosa' }
  ],
  'Oliveira do Hospital': [
    { designacao: 'Aldeia das Dez' },
    { designacao: 'Alvoco das Várzeas' },
    { designacao: 'Avô' },
    { designacao: 'Bobadela' },
    { designacao: 'Lagares' },
    { designacao: 'Lourosa' },
    { designacao: 'Meruge' },
    { designacao: 'Nogueira do Cravo' },
    { designacao: 'Seixo da Beira' },
    { designacao: 'São Gião' },
    { designacao: 'Travanca de Lagos' },
    { designacao: 'União das freguesias de Ervedal e Vila Franca da Beira' },
    { designacao: 'União das freguesias de Lagos da Beira e Lajeosa' },
    { designacao: 'União das freguesias de Oliveira do Hospital e São Paio de Gramaços' },
    { designacao: 'União das freguesias de Penalva de Alva e São Sebastião da Feira' },
    { designacao: 'União das freguesias de Santa Ovaia e Vila Pouca da Beira' }
  ],
  'Ourique': [
    { designacao: 'Ourique' },
    { designacao: 'Santana da Serra' },
    { designacao: 'União das freguesias de Garvão e Santa Luzia' },
    { designacao: 'União das freguesias de Panoias e Conceição' }
  ],
  'Ourém': [
    { designacao: 'Alburitel' },
    { designacao: 'Atouguia' },
    { designacao: 'Caxarias' },
    { designacao: 'Espite' },
    { designacao: 'Fátima' },
    { designacao: 'Nossa Senhora da Piedade' },
    { designacao: 'Nossa Senhora das Misericórdias' },
    { designacao: 'Seiça' },
    { designacao: 'União das freguesias de Freixianda, Ribeira do Fárrio e Formigais' },
    { designacao: 'União das freguesias de Gondemaria e Olival' },
    { designacao: 'União das freguesias de Matas e Cercal' },
    { designacao: 'União das freguesias de Rio de Couros e Casal dos Bernardos' },
    { designacao: 'Urqueira' }
  ],
  'Ovar': [
    { designacao: 'Cortegaça' },
    { designacao: 'Esmoriz' },
    { designacao: 'Maceda' },
    { designacao: 'União das freguesias de Ovar, São João, Arada e São Vicente de Pereira Jusã' },
    { designacao: 'Válega' }
  ],
  'Palmela': [
    { designacao: 'Palmela' },
    { designacao: 'Pinhal Novo' },
    { designacao: 'Quinta do Anjo' },
    { designacao: 'União das freguesias de Poceirão e Marateca' }
  ],
  'Pampilhosa da Serra': [
    { designacao: 'Cabril' },
    { designacao: 'Dornelas do Zêzere' },
    { designacao: 'Fajão - Vidual' },
    { designacao: 'Janeiro de Baixo' },
    { designacao: 'Pampilhosa da Serra' },
    { designacao: 'Pessegueiro' },
    { designacao: 'Portela do Fojo - Machio' },
    { designacao: 'Unhais-o-Velho' }
  ],
  'Paredes': [
    { designacao: 'Aguiar de Sousa' },
    { designacao: 'Astromil' },
    { designacao: 'Baltar' },
    { designacao: 'Beire' },
    { designacao: 'Cete' },
    { designacao: 'Cristelo' },
    { designacao: 'Duas Igrejas' },
    { designacao: 'Gandra' },
    { designacao: 'Lordelo' },
    { designacao: 'Louredo' },
    { designacao: 'Parada de Todeia' },
    { designacao: 'Paredes' },
    { designacao: 'Rebordosa' },
    { designacao: 'Recarei' },
    { designacao: 'Sobreira' },
    { designacao: 'Sobrosa' },
    { designacao: 'Vandoma' },
    { designacao: 'Vilela' }
  ],
  'Paredes de Coura': [
    { designacao: 'Agualonga' },
    { designacao: 'Castanheira' },
    { designacao: 'Coura' },
    { designacao: 'Cunha' },
    { designacao: 'Infesta' },
    { designacao: 'Mozelos' },
    { designacao: 'Padornelo' },
    { designacao: 'Parada' },
    { designacao: 'Romarigães' },
    { designacao: 'Rubiães' },
    { designacao: 'União das freguesias de Bico e Cristelo' },
    { designacao: 'União das freguesias de Cossourado e Linhares' },
    { designacao: 'União das freguesias de Formariz e Ferreira' },
    { designacao: 'União das freguesias de Insalde e Porreiras' },
    { designacao: 'União das freguesias de Paredes de Coura e Resende' },
    { designacao: 'Vascões' }
  ],
  'Paços de Ferreira': [
    { designacao: 'Carvalhosa' },
    { designacao: 'Eiriz' },
    { designacao: 'Ferreira' },
    { designacao: 'Figueiró' },
    { designacao: 'Frazão Arreigada' },
    { designacao: 'Freamunde' },
    { designacao: 'Meixomil' },
    { designacao: 'Paços de Ferreira' },
    { designacao: 'Penamaior' },
    { designacao: 'Raimonda' },
    { designacao: 'Sanfins Lamoso Codessos' },
    { designacao: 'Seroa' }
  ],
  'Pedrógão Grande': [
    { designacao: 'Graça' },
    { designacao: 'Pedrógão Grande' },
    { designacao: 'Vila Facaia' }
  ],
  'Penacova': [
    { designacao: 'Carvalho' },
    { designacao: 'Cercosa' },
    { designacao: 'Figueira de Lorvão' },
    { designacao: 'Lorvão' },
    { designacao: 'Penacova' },
    { designacao: 'Sazes do Lorvão' },
    { designacao: 'União das freguesias de Friúmes e Paradela' },
    { designacao: 'União das freguesias de Oliveira do Mondego e Travanca do Mondego' },
    { designacao: 'União das freguesias de São Pedro de Alva e São Paio de Mondego' }
  ],
  'Penafiel': [
    { designacao: 'Abragão' },
    { designacao: 'Boelhe' },
    { designacao: 'Bustelo' },
    { designacao: 'Cabeça Santa' },
    { designacao: 'Canelas' },
    { designacao: 'Capela' },
    { designacao: 'Castelões' },
    { designacao: 'Croca' },
    { designacao: 'Duas Igrejas' },
    { designacao: 'Eja' },
    { designacao: 'Fonte Arcada' },
    { designacao: 'Galegos' },
    { designacao: 'Guilhufe e Urrô' },
    { designacao: 'Irivo' },
    { designacao: 'Lagares e Figueira' },
    { designacao: 'Luzim e Vila Cova' },
    { designacao: 'Oldrões' },
    { designacao: 'Paço de Sousa' },
    { designacao: 'Penafiel' },
    { designacao: 'Perozelo' },
    { designacao: 'Rans' },
    { designacao: 'Recezinhos (São Mamede)' },
    { designacao: 'Rio Mau' },
    { designacao: 'Rio de Moinhos' },
    { designacao: 'Sebolido' },
    { designacao: 'Termas de São Vicente' },
    { designacao: 'Valpedre' }
  ],
  'Penalva do Castelo': [
    { designacao: 'Castelo de Penalva' },
    { designacao: 'Esmolfe' },
    { designacao: 'Germil' },
    { designacao: 'Lusinde' },
    { designacao: 'Pindo' },
    { designacao: 'Real' },
    { designacao: 'Sezures' },
    { designacao: 'Trancozelos' },
    { designacao: 'União das freguesias de Antas e Matela' },
    { designacao: 'União das freguesias de Vila Cova do Covelo/Mareco' },
    { designacao: 'Ínsua' }
  ],
  'Penamacor': [
    { designacao: 'Aranhas' },
    { designacao: 'Benquerença' },
    { designacao: 'Meimoa' },
    { designacao: 'Meimão' },
    { designacao: 'Penamacor' },
    { designacao: 'Salvador' },
    { designacao: 'União das freguesias de Aldeia do Bispo, Águas e Aldeia de João Pires' },
    { designacao: 'União das freguesias de Pedrógão de São Pedro e Bemposta' },
    { designacao: 'Vale da Senhora da Póvoa' }
  ],
  'Penedono': [
    { designacao: 'Beselga' },
    { designacao: 'Castainço' },
    { designacao: 'Penela da Beira' },
    { designacao: 'Póvoa de Penela' },
    { designacao: 'Souto' },
    { designacao: 'União das freguesias de Antas e Ourozinho' },
    { designacao: 'União das freguesias de Penedono e Granja' }
  ],
  'Penela': [
    { designacao: 'Cumeeira' },
    { designacao: 'Espinhal' },
    { designacao: 'Podentes' },
    { designacao: 'União das freguesias de São Miguel, Santa Eufémia e Rabaçal' }
  ],
  'Peniche': [
    { designacao: 'Atouguia da Baleia' },
    { designacao: 'Ferrel' },
    { designacao: 'Peniche' },
    { designacao: 'Serra d\'El-Rei' },
    { designacao: 'União das freguesias de Miragaia e Marteleira' }
  ],
  'Peso da Régua': [
    { designacao: 'Fontelas' },
    { designacao: 'Loureiro' },
    { designacao: 'Sedielos' },
    { designacao: 'União das freguesias de Galafura e Covelinhas' },
    { designacao: 'União das freguesias de Moura Morta e Vinhós' },
    { designacao: 'União das freguesias de Peso da Régua e Godim' },
    { designacao: 'União das freguesias de Poiares e Canelas' },
    { designacao: 'Vilarinho dos Freires' }
  ],
  'Pinhel': [
    { designacao: 'Agregação das freguesias Sul de Pinhel' },
    { designacao: 'Alto do Palurdo' },
    { designacao: 'Alverca da Beira/Bouça Cova' },
    { designacao: 'Ervedosa' },
    { designacao: 'Freixedas' },
    { designacao: 'Lamegal' },
    { designacao: 'Lameiras' },
    { designacao: 'Manigoto' },
    { designacao: 'Pala' },
    { designacao: 'Pinhel' },
    { designacao: 'Pínzio' },
    { designacao: 'Souro Pires' },
    { designacao: 'Terras de Massueime' },
    { designacao: 'União das freguesias de Atalaia e Safurdão' },
    { designacao: 'Valbom/Bogalhal' },
    { designacao: 'Vale do Côa' },
    { designacao: 'Vale do Massueime' },
    { designacao: 'Vascoveiro' }
  ],
  'Pombal': [
    { designacao: 'Abiul' },
    { designacao: 'Almagreira' },
    { designacao: 'Carnide' },
    { designacao: 'Carriço' },
    { designacao: 'Louriçal' },
    { designacao: 'Meirinhas' },
    { designacao: 'Pelariga' },
    { designacao: 'Pombal' },
    { designacao: 'Redinha' },
    { designacao: 'União das freguesias de Guia, Ilha e Mata Mourisca' },
    { designacao: 'União das freguesias de Santiago e São Simão de Litém e Albergaria dos Doze' },
    { designacao: 'Vermoil' },
    { designacao: 'Vila Cã' }
  ],
  'Ponta Delgada': [
    { designacao: 'Ajuda da Bretanha' },
    { designacao: 'Arrifes' },
    { designacao: 'Candelária' },
    { designacao: 'Capelas' },
    { designacao: 'Covoada' },
    { designacao: 'Fajã de Baixo' },
    { designacao: 'Fajã de Cima' },
    { designacao: 'Fenais da Luz' },
    { designacao: 'Feteiras' },
    { designacao: 'Ginetes' },
    { designacao: 'Mosteiros' },
    { designacao: 'Pilar da Bretanha' },
    { designacao: 'Ponta Delgada (São José)' },
    { designacao: 'Ponta Delgada (São Pedro)' },
    { designacao: 'Ponta Delgada (São Sebastião)' },
    { designacao: 'Relva' },
    { designacao: 'Remédios' },
    { designacao: 'Rosto do Cão (Livramento)' },
    { designacao: 'Rosto do Cão (São Roque)' },
    { designacao: 'Santa Bárbara' },
    { designacao: 'Santo António' },
    { designacao: 'Sete Cidades' },
    { designacao: 'São Vicente Ferreira' }
  ],
  'Ponta do Sol': [
    { designacao: 'Canhas' },
    { designacao: 'Madalena do Mar' },
    { designacao: 'Ponta do Sol' }
  ],
  'Ponte da Barca': [
    { designacao: 'Azias' },
    { designacao: 'Boivães' },
    { designacao: 'Bravães' },
    { designacao: 'Britelo' },
    { designacao: 'Cuide de Vila Verde' },
    { designacao: 'Lavradas' },
    { designacao: 'Lindoso' },
    { designacao: 'Nogueira' },
    { designacao: 'Oleiros' },
    { designacao: 'Sampriz' },
    { designacao: 'União das freguesias de Crasto, Ruivos e Grovelas' },
    { designacao: 'União das freguesias de Entre Ambos-os-Rios, Ermida e Germil' },
    { designacao: 'União das freguesias de Ponte da Barca, Vila Nova de Muía e Paço Vedro de Magalhães' },
    { designacao: 'União das freguesias de Touvedo (São Lourenço e Salvador)' },
    { designacao: 'União das freguesias de Vila Chã (São João Baptista e Santiago)' },
    { designacao: 'Vade (São Pedro)' },
    { designacao: 'Vade (São Tomé)' }
  ],
  'Ponte de Lima': [
    { designacao: 'Anais' },
    { designacao: 'Arca e Ponte de Lima' },
    { designacao: 'Arcozelo' },
    { designacao: 'Ardegão, Freixo e Mato' },
    { designacao: 'Associação de freguesias do Vale do Neiva' },
    { designacao: 'Beiral do Lima' },
    { designacao: 'Bertiandos' },
    { designacao: 'Boalhosa' },
    { designacao: 'Brandara' },
    { designacao: 'Bárrio e Cepões' },
    { designacao: 'Cabaços e Fojo Lobal' },
    { designacao: 'Cabração e Moreira do Lima' },
    { designacao: 'Calheiros' },
    { designacao: 'Calvelo' },
    { designacao: 'Correlhã' },
    { designacao: 'Estorãos' },
    { designacao: 'Facha' },
    { designacao: 'Feitosa' },
    { designacao: 'Fontão' },
    { designacao: 'Fornelos e Queijada' },
    { designacao: 'Friastelas' },
    { designacao: 'Gandra' },
    { designacao: 'Gemieira' },
    { designacao: 'Gondufe' },
    { designacao: 'Labruja' },
    { designacao: 'Labrujó, Rendufe e Vilar do Monte' },
    { designacao: 'Navió e Vitorino dos Piães' },
    { designacao: 'Poiares' },
    { designacao: 'Rebordões (Santa Maria)' },
    { designacao: 'Refóios do Lima' },
    { designacao: 'Ribeira' },
    { designacao: 'Santa Comba' },
    { designacao: 'Santa Cruz do Lima' },
    { designacao: 'Seara' },
    { designacao: 'Serdedelo' },
    { designacao: 'Sá' },
    { designacao: 'São Pedro d\'Arcos' },
    { designacao: 'Vitorino das Donas' }
  ],
  'Ponte de Sor': [
    { designacao: 'Foros de Arrão' },
    { designacao: 'Galveias' },
    { designacao: 'Longomel' },
    { designacao: 'Montargil' },
    { designacao: 'União das freguesias de Ponte de Sor, Tramaga e Vale de Açor' }
  ],
  'Portalegre': [
    { designacao: 'Alagoa' },
    { designacao: 'Alegrete' },
    { designacao: 'Fortios' },
    { designacao: 'União das freguesias da Sé e São Lourenço' },
    { designacao: 'União das freguesias de Reguengo e São Julião' },
    { designacao: 'União das freguesias de Ribeira de Nisa e Carreiras' },
    { designacao: 'Urra' }
  ],
  'Portel': [
    { designacao: 'Monte do Trigo' },
    { designacao: 'Portel' },
    { designacao: 'Santana' },
    { designacao: 'União das freguesias de Amieira e Alqueva' },
    { designacao: 'União das freguesias de São Bartolomeu do Outeiro e Oriola' },
    { designacao: 'Vera Cruz' }
  ],
  'Portimão': [
    { designacao: 'Alvor' },
    { designacao: 'Mexilhoeira Grande' },
    { designacao: 'Portimão' }
  ],
  'Porto': [
    { designacao: 'Bonfim' },
    { designacao: 'Campanhã' },
    { designacao: 'Paranhos' },
    { designacao: 'Ramalde' },
    { designacao: 'União das freguesias de Aldoar, Foz do Douro e Nevogilde' },
    { designacao: 'União das freguesias de Cedofeita, Santo Ildefonso, Sé, Miragaia, São Nicolau e Vitória' },
    { designacao: 'União das freguesias de Lordelo do Ouro e Massarelos' }
  ],
  'Porto Moniz': [
    { designacao: 'Achadas da Cruz' },
    { designacao: 'Porto Moniz' },
    { designacao: 'Ribeira da Janela' },
    { designacao: 'Seixal' }
  ],
  'Porto Santo': [
    { designacao: 'Porto Santo' }
  ],
  'Porto de Mós': [
    { designacao: 'Alqueidão da Serra' },
    { designacao: 'Calvaria de Cima' },
    { designacao: 'Juncal' },
    { designacao: 'Mira de Aire' },
    { designacao: 'Pedreiras' },
    { designacao: 'Porto de Mós - São João Baptista e São Pedro' },
    { designacao: 'Serro Ventoso' },
    { designacao: 'São Bento' },
    { designacao: 'União das freguesias de Alvados e Alcaria' },
    { designacao: 'União das freguesias de Arrimal e Mendiga' }
  ],
  'Povoação': [
    { designacao: 'Faial da Terra' },
    { designacao: 'Furnas' },
    { designacao: 'Nossa Senhora dos Remédios' },
    { designacao: 'Povoação' },
    { designacao: 'Ribeira Quente' },
    { designacao: 'Água Retorta' }
  ],
  'Praia da Vitória': [
    { designacao: 'Agualva' },
    { designacao: 'Biscoitos' },
    { designacao: 'Cabo da Praia' },
    { designacao: 'Fonte do Bastardo' },
    { designacao: 'Fontinhas' },
    { designacao: 'Lajes' },
    { designacao: 'Porto Martins' },
    { designacao: 'Praia da Vitória (Santa Cruz)' },
    { designacao: 'Quatro Ribeiras' },
    { designacao: 'São Brás' },
    { designacao: 'Vila Nova' }
  ],
  'Proença-a-Nova': [
    { designacao: 'Montes da Senhora' },
    { designacao: 'São Pedro do Esteval' },
    { designacao: 'União das freguesias de Proença-a-Nova e Peral' },
    { designacao: 'União das freguesias de Sobreira Formosa e Alvito da Beira' }
  ],
  'Póvoa de Lanhoso': [
    { designacao: 'Covelas' },
    { designacao: 'Ferreiros' },
    { designacao: 'Galegos' },
    { designacao: 'Garfe' },
    { designacao: 'Geraz do Minho' },
    { designacao: 'Lanhoso' },
    { designacao: 'Monsul' },
    { designacao: 'Póvoa de Lanhoso (Nossa Senhora do Amparo)' },
    { designacao: 'Rendufinho' },
    { designacao: 'Santo Emilião' },
    { designacao: 'Serzedelo' },
    { designacao: 'Sobradelo da Goma' },
    { designacao: 'São João de Rei' },
    { designacao: 'Taíde' },
    { designacao: 'Travassos' },
    { designacao: 'União das freguesias de Calvos e Frades' },
    { designacao: 'União das freguesias de Campos e Louredo' },
    { designacao: 'União das freguesias de Esperança e Brunhais' },
    { designacao: 'União das freguesias de Fonte Arcada e Oliveira' },
    { designacao: 'União das freguesias de Verim, Friande e Ajude' },
    { designacao: 'União das freguesias de Águas Santas e Moure' },
    { designacao: 'Vilela' }
  ],
  'Póvoa de Varzim': [
    { designacao: 'Balazar' },
    { designacao: 'Estela' },
    { designacao: 'Laundos' },
    { designacao: 'Rates' },
    { designacao: 'União das freguesias da Póvoa de Varzim, Beiriz e Argivai' },
    { designacao: 'União das freguesias de Aguçadoura e Navais' },
    { designacao: 'União das freguesias de Aver-o-Mar, Amorim e Terroso' }
  ],
  'Redondo': [
    { designacao: 'Montoito' },
    { designacao: 'Redondo' }
  ],
  'Reguengos de Monsaraz': [
    { designacao: 'Corval' },
    { designacao: 'Monsaraz' },
    { designacao: 'Reguengos de Monsaraz' },
    { designacao: 'União das freguesias de Campo e Campinho' }
  ],
  'Resende': [
    { designacao: 'Barrô' },
    { designacao: 'Cárquere' },
    { designacao: 'Paus' },
    { designacao: 'Resende' },
    { designacao: 'São Cipriano' },
    { designacao: 'São João de Fontoura' },
    { designacao: 'São Martinho de Mouros' },
    { designacao: 'União das freguesias de Anreade e São Romão de Aregos' },
    { designacao: 'União das freguesias de Felgueiras e Feirão' },
    { designacao: 'União das freguesias de Freigil e Miomães' },
    { designacao: 'União das freguesias de Ovadas e Panchorra' }
  ],
  'Ribeira Brava': [
    { designacao: 'Campanário' },
    { designacao: 'Ribeira Brava' },
    { designacao: 'Serra de Água' },
    { designacao: 'Tábua' }
  ],
  'Ribeira Grande': [
    { designacao: 'Calhetas' },
    { designacao: 'Fenais da Ajuda' },
    { designacao: 'Lomba da Maia' },
    { designacao: 'Lomba de São Pedro' },
    { designacao: 'Maia' },
    { designacao: 'Pico da Pedra' },
    { designacao: 'Porto Formoso' },
    { designacao: 'Rabo de Peixe' },
    { designacao: 'Ribeira Grande (Conceição)' },
    { designacao: 'Ribeira Grande (Matriz)' },
    { designacao: 'Ribeira Seca' },
    { designacao: 'Ribeirinha' },
    { designacao: 'Santa Bárbara' },
    { designacao: 'São Brás' }
  ],
  'Ribeira de Pena': [
    { designacao: 'Alvadia' },
    { designacao: 'Canedo' },
    { designacao: 'Santa Marinha' },
    { designacao: 'União das freguesias de Cerva e Limões' },
    { designacao: 'União das freguesias de Ribeira de Pena (Salvador) e Santo Aleixo de Além-Tâmega' }
  ],
  'Rio Maior': [
    { designacao: 'Alcobertas' },
    { designacao: 'Arrouquelas' },
    { designacao: 'Asseiceira' },
    { designacao: 'Fráguas' },
    { designacao: 'Rio Maior' },
    { designacao: 'São Sebastião' },
    { designacao: 'União das freguesias de Azambujeira e Malaqueijo' },
    { designacao: 'União das freguesias de Marmeleira e Assentiz' },
    { designacao: 'União das freguesias de Outeiro da Cortiçada e Arruda dos Pisões' },
    { designacao: 'União das freguesias de São João da Ribeira e Ribeira de São João' }
  ],
  'Sabrosa': [
    { designacao: 'Celeirós' },
    { designacao: 'Covas do Douro' },
    { designacao: 'Gouvinhas' },
    { designacao: 'Parada de Pinhão' },
    { designacao: 'Paços' },
    { designacao: 'Sabrosa' },
    { designacao: 'Souto Maior' },
    { designacao: 'São Lourenço de Ribapinhão' },
    { designacao: 'Torre do Pinhão' },
    { designacao: 'União das freguesias de Provesende, Gouvães do Douro e São Cristóvão do Douro' },
    { designacao: 'União das freguesias de São Martinho de Antas e Paradela de Guiães' },
    { designacao: 'Vilarinho de São Romão' }
  ],
  'Sabugal': [
    { designacao: 'Aldeia Velha' },
    { designacao: 'Aldeia da Ponte' },
    { designacao: 'Aldeia do Bispo' },
    { designacao: 'Alfaiates' },
    { designacao: 'Baraçal' },
    { designacao: 'Bendada' },
    { designacao: 'Bismula' },
    { designacao: 'Casteleiro' },
    { designacao: 'Cerdeira' },
    { designacao: 'Fóios' },
    { designacao: 'Malcata' },
    { designacao: 'Nave' },
    { designacao: 'Quadrazais' },
    { designacao: 'Quintas de São Bartolomeu' },
    { designacao: 'Rapoula do Côa' },
    { designacao: 'Rebolosa' },
    { designacao: 'Rendo' },
    { designacao: 'Sortelha' },
    { designacao: 'Souto' },
    { designacao: 'União das freguesias de Aldeia da Ribeira, Vilar Maior e Badamalos' },
    { designacao: 'União das freguesias de Lajeosa e Forcalhos' },
    { designacao: 'União das freguesias de Pousafoles do Bispo, Pena Lobo e Lomba' },
    { designacao: 'União das freguesias de Ruvina, Ruivós e Vale das Éguas' },
    { designacao: 'União das freguesias de Sabugal e Aldeia de Santo António' },
    { designacao: 'União das freguesias de Santo Estêvão e Moita' },
    { designacao: 'União das freguesias de Seixo do Côa e Vale Longo' },
    { designacao: 'Vale de Espinho' },
    { designacao: 'Vila Boa' },
    { designacao: 'Vila do Touro' },
    { designacao: 'Águas Belas' }
  ],
  'Salvaterra de Magos': [
    { designacao: 'Marinhais' },
    { designacao: 'Muge' },
    { designacao: 'União das freguesias de Glória do Ribatejo e Granho' },
    { designacao: 'União das freguesias de Salvaterra de Magos e Foros de Salvaterra' }
  ],
  'Santa Comba Dão': [
    { designacao: 'Pinheiro de Ázere' },
    { designacao: 'São Joaninho' },
    { designacao: 'São João de Areias' },
    { designacao: 'União das freguesias de Ovoa e Vimieiro' },
    { designacao: 'União das freguesias de Santa Comba Dão e Couto do Mosteiro' },
    { designacao: 'União das freguesias de Treixedo e Nagozela' }
  ],
  'Santa Cruz': [
    { designacao: 'Camacha' },
    { designacao: 'Caniço' },
    { designacao: 'Gaula' },
    { designacao: 'Santa Cruz' },
    { designacao: 'Santo António da Serra' }
  ],
  'Santa Cruz da Graciosa': [
    { designacao: 'Guadalupe (R.A.Açores)' },
    { designacao: 'Luz (R.A.Açores)' },
    { designacao: 'Praia (São Mateus) (R.A.Açores)' },
    { designacao: 'Santa Cruz da Graciosa (R.A.Açores)' }
  ],
  'Santa Cruz das Flores': [
    { designacao: 'Caveira' },
    { designacao: 'Cedros' },
    { designacao: 'Ponta Delgada' },
    { designacao: 'Santa Cruz das Flores' }
  ],
  'Santa Maria da Feira': [
    { designacao: 'Argoncilhe' },
    { designacao: 'Arrifana' },
    { designacao: 'Escapães' },
    { designacao: 'Fiães' },
    { designacao: 'Fornos' },
    { designacao: 'Lourosa' },
    { designacao: 'Milheirós de Poiares' },
    { designacao: 'Mozelos' },
    { designacao: 'Nogueira da Regedoura' },
    { designacao: 'Paços de Brandão' },
    { designacao: 'Rio Meão' },
    { designacao: 'Romariz' },
    { designacao: 'Sanguedo' },
    { designacao: 'Santa Maria de Lamas' },
    { designacao: 'São João da Madeira' },
    { designacao: 'São João de Ver' },
    { designacao: 'São Paio de Oleiros' },
    { designacao: 'União das freguesias de Caldas de São Jorge e Pigeiros' },
    { designacao: 'União das freguesias de Canedo, Vale e Vila Maior' },
    { designacao: 'União das freguesias de Lobão, Gião, Louredo e Guisande' },
    { designacao: 'União das freguesias de Santa Maria da Feira, Travanca, Sanfins e Espargo' },
    { designacao: 'União das freguesias de São Miguel do Souto e Mosteirô' }
  ],
  'Santa Marta de Penaguião': [
    { designacao: 'Alvações do Corgo' },
    { designacao: 'Cumieira' },
    { designacao: 'Fontes' },
    { designacao: 'Medrões' },
    { designacao: 'Sever' },
    { designacao: 'União das freguesias de Lobrigos (São Miguel e São João Baptista) e Sanhoane' },
    { designacao: 'União das freguesias de Louredo e Fornelos' }
  ],
  'Santana': [
    { designacao: 'Arco de São Jorge' },
    { designacao: 'Faial' },
    { designacao: 'Ilha' },
    { designacao: 'Santana' },
    { designacao: 'São Jorge' },
    { designacao: 'São Roque do Faial' }
  ],
  'Santarém': [
    { designacao: 'Abitureiras' },
    { designacao: 'Abrã' },
    { designacao: 'Alcanede' },
    { designacao: 'Alcanhões' },
    { designacao: 'Almoster' },
    { designacao: 'Amiais de Baixo' },
    { designacao: 'Arneiro das Milhariças' },
    { designacao: 'Gançaria' },
    { designacao: 'Moçarria' },
    { designacao: 'Pernes' },
    { designacao: 'Póvoa da Isenta' },
    { designacao: 'União das freguesias de Achete, Azoia de Baixo e Póvoa de Santarém' },
    { designacao: 'União das freguesias de Azoia de Cima e Tremês' },
    { designacao: 'União das freguesias de Casével e Vaqueiros' },
    { designacao: 'União das freguesias de Romeira e Várzea' },
    { designacao: 'União das freguesias de Santarém (Marvila), Santa Iria da Ribeira de Santarém, Santarém (São Salvador) e Santarém (São Nicolau)' },
    { designacao: 'União das freguesias de São Vicente do Paul e Vale de Figueira' },
    { designacao: 'Vale de Santarém' }
  ],
  'Santiago do Cacém': [
    { designacao: 'Abela' },
    { designacao: 'Alvalade' },
    { designacao: 'Cercal' },
    { designacao: 'Ermidas-Sado' },
    { designacao: 'Santo André' },
    { designacao: 'São Francisco da Serra' },
    { designacao: 'União das freguesias de Santiago do Cacém, Santa Cruz e São Bartolomeu da Serra' },
    { designacao: 'União das freguesias de São Domingos e Vale de Água' }
  ],
  'Santo Tirso': [
    { designacao: 'Agrela' },
    { designacao: 'Aves' },
    { designacao: 'Monte Córdova' },
    { designacao: 'Negrelos (São Tomé)' },
    { designacao: 'Rebordões' },
    { designacao: 'Reguenga' },
    { designacao: 'Roriz' },
    { designacao: 'União das freguesias de Areias, Sequeiró, Lama e Palmeira' },
    { designacao: 'União das freguesias de Campo (São Martinho), São Salvador do Campo e Negrelos (São Mamede)' },
    { designacao: 'União das freguesias de Carreira e Refojos de Riba de Ave' },
    { designacao: 'União das freguesias de Lamelas e Guimarei' },
    { designacao: 'União das freguesias de Santo Tirso, Couto (Santa Cristina e São Miguel) e Burgães' },
    { designacao: 'Vilarinho' },
    { designacao: 'Água Longa' }
  ],
  'Sardoal': [
    { designacao: 'Alcaravela' },
    { designacao: 'Santiago de Montalegre' },
    { designacao: 'Sardoal' },
    { designacao: 'Valhascos' }
  ],
  'Seia': [
    { designacao: 'Alvoco da Serra' },
    { designacao: 'Girabolhos' },
    { designacao: 'Loriga' },
    { designacao: 'Paranhos' },
    { designacao: 'Pinhanços' },
    { designacao: 'Sabugueiro' },
    { designacao: 'Sandomil' },
    { designacao: 'Santa Comba' },
    { designacao: 'Santiago' },
    { designacao: 'Sazes da Beira' },
    { designacao: 'Teixeira' },
    { designacao: 'Travancinha' },
    { designacao: 'União das freguesias de Carragozela e Várzea de Meruge' },
    { designacao: 'União das freguesias de Sameice e Santa Eulália' },
    { designacao: 'União das freguesias de Santa Marinha e São Martinho' },
    { designacao: 'União das freguesias de Seia, São Romão e Lapa dos Dinheiros' },
    { designacao: 'União das freguesias de Torrozelo e Folhadosa' },
    { designacao: 'União das freguesias de Tourais e Lajes' },
    { designacao: 'União das freguesias de Vide e Cabeça' },
    { designacao: 'Valezim' },
    { designacao: 'Vila Cova à Coelheira' }
  ],
  'Seixal': [
    { designacao: 'Amora' },
    { designacao: 'Corroios' },
    { designacao: 'Fernão Ferro' },
    { designacao: 'União das freguesias do Seixal, Arrentela e Aldeia de Paio Pires' }
  ],
  'Sernancelhe': [
    { designacao: 'Arnas' },
    { designacao: 'Carregal' },
    { designacao: 'Chosendo' },
    { designacao: 'Cunha' },
    { designacao: 'Faia' },
    { designacao: 'Granjal' },
    { designacao: 'Lamosa' },
    { designacao: 'Quintela' },
    { designacao: 'União das freguesias de Ferreirim e Macieira' },
    { designacao: 'União das freguesias de Fonte Arcada e Escurquela' },
    { designacao: 'União das freguesias de Penso e Freixinho' },
    { designacao: 'União das freguesias de Sernancelhe e Sarzeda' },
    { designacao: 'Vila da Ponte' }
  ],
  'Serpa': [
    { designacao: 'Brinches' },
    { designacao: 'Pias' },
    { designacao: 'União das freguesias de Serpa (Salvador e Santa Maria)' },
    { designacao: 'União das freguesias de Vila Nova de São Bento e Vale de Vargo' },
    { designacao: 'Vila Verde de Ficalho' }
  ],
  'Sertã': [
    { designacao: 'Cabeçudo' },
    { designacao: 'Carvalhal' },
    { designacao: 'Castelo' },
    { designacao: 'Pedrógão Pequeno' },
    { designacao: 'Sertã' },
    { designacao: 'Troviscal' },
    { designacao: 'União das freguesias de Cernache do Bonjardim, Nesperal e Palhais' },
    { designacao: 'União das freguesias de Cumeada e Marmeleiro' },
    { designacao: 'União das freguesias de Ermida e Figueiredo' },
    { designacao: 'Várzea dos Cavaleiros' }
  ],
  'Sesimbra': [
    { designacao: 'Quinta do Conde' },
    { designacao: 'Sesimbra (Castelo)' }
  ],
  'Setúbal': [
    { designacao: 'Gâmbia-Pontes-Alto da Guerra' },
    { designacao: 'Sado' },
    { designacao: 'Setúbal (São Sebastião)' },
    { designacao: 'União das freguesias de Azeitão (São Lourenço e São Simão)' },
    { designacao: 'União das freguesias de Setúbal (São Julião, Nossa Senhora da Anunciada e Santa Maria da Graça)' }
  ],
  'Sever do Vouga': [
    { designacao: 'Couto de Esteves' },
    { designacao: 'Pessegueiro do Vouga' },
    { designacao: 'Rocas do Vouga' },
    { designacao: 'Sever do Vouga' },
    { designacao: 'Talhadas' },
    { designacao: 'União das freguesias de Cedrim e Paradela' },
    { designacao: 'União das freguesias de Silva Escura e Dornelas' }
  ],
  'Silves': [
    { designacao: 'Armação de Pêra' },
    { designacao: 'Silves' },
    { designacao: 'São Bartolomeu de Messines' },
    { designacao: 'São Marcos da Serra' },
    { designacao: 'União das freguesias de Alcantarilha e Pêra' },
    { designacao: 'União das freguesias de Algoz e Tunes' }
  ],
  'Sines': [
    { designacao: 'Porto Covo' },
    { designacao: 'Sines' }
  ],
  'Sintra': [
    { designacao: 'Algueirão-Mem Martins' },
    { designacao: 'Casal de Cambra' },
    { designacao: 'Colares' },
    { designacao: 'Rio de Mouro' },
    { designacao: 'União das freguesias de Agualva e Mira-Sintra' },
    { designacao: 'União das freguesias de Almargem do Bispo, Pêro Pinheiro e Montelavar' },
    { designacao: 'União das freguesias de Massamá e Monte Abraão' },
    { designacao: 'União das freguesias de Queluz e Belas' },
    { designacao: 'União das freguesias de Sintra (Santa Maria e São Miguel, São Martinho e São Pedro de Penaferrim)' },
    { designacao: 'União das freguesias de São João das Lampas e Terrugem' },
    { designacao: 'União das freguesias do Cacém e São Marcos' }
  ],
  'Sobral de Monte Agraço': [
    { designacao: 'Santo Quintino' },
    { designacao: 'Sapataria' },
    { designacao: 'Sobral de Monte Agraço' }
  ],
  'Soure': [
    { designacao: 'Alfarelos' },
    { designacao: 'Figueiró do Campo' },
    { designacao: 'Granja do Ulmeiro' },
    { designacao: 'Samuel' },
    { designacao: 'Soure' },
    { designacao: 'Tapéus' },
    { designacao: 'União das freguesias de Degracias e Pombalinho' },
    { designacao: 'União das freguesias de Gesteira e Brunhós' },
    { designacao: 'Vila Nova de Anços' },
    { designacao: 'Vinha da Rainha' }
  ],
  'Sousel': [
    { designacao: 'Cano' },
    { designacao: 'Casa Branca' },
    { designacao: 'Santo Amaro' },
    { designacao: 'Sousel' }
  ],
  'Sátão': [
    { designacao: 'Avelal' },
    { designacao: 'Ferreira de Aves' },
    { designacao: 'Mioma' },
    { designacao: 'Rio de Moinhos' },
    { designacao: 'Silvã de Cima' },
    { designacao: 'Sátão' },
    { designacao: 'São Miguel de Vila Boa' },
    { designacao: 'União das freguesias de Romãs, Decermilo e Vila Longa' },
    { designacao: 'União das freguesias de Águas Boas e Forles' }
  ],
  'São Brás de Alportel': [
    { designacao: 'São Brás de Alportel' }
  ],
  'São João da Madeira': [
    { designacao: 'São João da Madeira' }
  ],
  'São João da Pesqueira': [
    { designacao: 'Castanheiro do Sul' },
    { designacao: 'Ervedosa do Douro' },
    { designacao: 'Nagozelo do Douro' },
    { designacao: 'Paredes da Beira' },
    { designacao: 'Riodades' },
    { designacao: 'Soutelo do Douro' },
    { designacao: 'União das freguesias de São João da Pesqueira e Várzea de Trevões' },
    { designacao: 'União das freguesias de Trevões e Espinhosa' },
    { designacao: 'União das freguesias de Vilarouco e Pereiros' },
    { designacao: 'Vale de Figueira' },
    { designacao: 'Valongo dos Azeites' }
  ],
  'São Pedro do Sul': [
    { designacao: 'Bordonhos' },
    { designacao: 'Figueiredo de Alva' },
    { designacao: 'Manhouce' },
    { designacao: 'Pindelo dos Milagres' },
    { designacao: 'Pinho' },
    { designacao: 'Serrazes' },
    { designacao: 'Sul' },
    { designacao: 'São Félix' },
    { designacao: 'União das freguesias de Carvalhais e Candal' },
    { designacao: 'União das freguesias de Santa Cruz da Trapa e São Cristóvão de Lafões' },
    { designacao: 'União das freguesias de São Martinho das Moitas e Covas do Rio' },
    { designacao: 'União das freguesias de São Pedro do Sul, Várzea e Baiões' },
    { designacao: 'Valadares' },
    { designacao: 'Vila Maior' }
  ],
  'São Roque do Pico': [
    { designacao: 'Prainha' },
    { designacao: 'Santa Luzia' },
    { designacao: 'Santo Amaro' },
    { designacao: 'Santo António' },
    { designacao: 'São Roque do Pico' }
  ],
  'São Vicente': [
    { designacao: 'Boa Ventura' },
    { designacao: 'Ponta Delgada' },
    { designacao: 'São Vicente' }
  ],
  'Tabuaço': [
    { designacao: 'Adorigo' },
    { designacao: 'Arcos' },
    { designacao: 'Chavães' },
    { designacao: 'Desejosa' },
    { designacao: 'Granja do Tedo' },
    { designacao: 'Longa' },
    { designacao: 'Sendim' },
    { designacao: 'Tabuaço' },
    { designacao: 'União das freguesias de Barcos e Santa Leocádia' },
    { designacao: 'União das freguesias de Paradela e Granjinha' },
    { designacao: 'União das freguesias de Pinheiros e Vale de Figueira' },
    { designacao: 'União das freguesias de Távora e Pereiro' },
    { designacao: 'Valença do Douro' }
  ],
  'Tarouca': [
    { designacao: 'Mondim da Beira' },
    { designacao: 'Salzedas' },
    { designacao: 'São João de Tarouca' },
    { designacao: 'União das freguesias de Gouviães e Ucanha' },
    { designacao: 'União das freguesias de Granja Nova e Vila Chã da Beira' },
    { designacao: 'União das freguesias de Tarouca e Dálvares' },
    { designacao: 'Várzea da Serra' }
  ],
  'Tavira': [
    { designacao: 'Cachopo' },
    { designacao: 'Santa Catarina da Fonte do Bispo' },
    { designacao: 'Santa Luzia' },
    { designacao: 'União das freguesias de Conceição e Cabanas de Tavira' },
    { designacao: 'União das freguesias de Luz de Tavira e Santo Estêvão' },
    { designacao: 'União das freguesias de Tavira (Santa Maria e Santiago)' }
  ],
  'Terras de Bouro': [
    { designacao: 'Balança' },
    { designacao: 'Campo do Gerês' },
    { designacao: 'Carvalheira' },
    { designacao: 'Covide' },
    { designacao: 'Gondoriz' },
    { designacao: 'Moimenta' },
    { designacao: 'Ribeira' },
    { designacao: 'Rio Caldo' },
    { designacao: 'Souto' },
    { designacao: 'União das freguesias de Chamoim e Vilar' },
    { designacao: 'União das freguesias de Chorense e Monte' },
    { designacao: 'União das freguesias de Cibões e Brufe' },
    { designacao: 'Valdosende' },
    { designacao: 'Vilar da Veiga' }
  ],
  'Tomar': [
    { designacao: 'Asseiceira' },
    { designacao: 'Carregueiros' },
    { designacao: 'Olalhas' },
    { designacao: 'Paialvo' },
    { designacao: 'Sabacheira' },
    { designacao: 'São Pedro de Tomar' },
    { designacao: 'União das freguesias de Além da Ribeira e Pedreira' },
    { designacao: 'União das freguesias de Casais e Alviobeira' },
    { designacao: 'União das freguesias de Madalena e Beselga' },
    { designacao: 'União das freguesias de Serra e Junceira' },
    { designacao: 'União das freguesias de Tomar (São João Baptista) e Santa Maria dos Olivais' }
  ],
  'Tondela': [
    { designacao: 'Campo de Besteiros' },
    { designacao: 'Canas de Santa Maria' },
    { designacao: 'Castelões' },
    { designacao: 'Dardavaz' },
    { designacao: 'Ferreirós do Dão' },
    { designacao: 'Guardão' },
    { designacao: 'Lajeosa do Dão' },
    { designacao: 'Lobão da Beira' },
    { designacao: 'Molelos' },
    { designacao: 'Parada de Gonta' },
    { designacao: 'Santiago de Besteiros' },
    { designacao: 'Tonda' },
    { designacao: 'União das freguesias de Barreiro de Besteiros e Tourigo' },
    { designacao: 'União das freguesias de Caparrosa e Silvares' },
    { designacao: 'União das freguesias de Mouraz e Vila Nova da Rainha' },
    { designacao: 'União das freguesias de São João do Monte e Mosteirinho' },
    { designacao: 'União das freguesias de São Miguel do Outeiro e Sabugosa' },
    { designacao: 'União das freguesias de Tondela e Nandufe' },
    { designacao: 'União das freguesias de Vilar de Besteiros e Mosteiro de Fráguas' }
  ],
  'Torre de Moncorvo': [
    { designacao: 'Açoreira' },
    { designacao: 'Cabeça Boa' },
    { designacao: 'Carviçais' },
    { designacao: 'Castedo' },
    { designacao: 'Horta da Vilariça' },
    { designacao: 'Larinho' },
    { designacao: 'Lousa' },
    { designacao: 'Mós' },
    { designacao: 'Torre de Moncorvo' },
    { designacao: 'União das freguesias de Adeganha e Cardanha' },
    { designacao: 'União das freguesias de Felgar e Souto da Velha' },
    { designacao: 'União das freguesias de Felgueiras e Maçores' },
    { designacao: 'União das freguesias de Urros e Peredo dos Castelhanos' }
  ],
  'Torres Novas': [
    { designacao: 'Assentiz' },
    { designacao: 'Chancelaria' },
    { designacao: 'Meia Via' },
    { designacao: 'Pedrógão' },
    { designacao: 'Riachos' },
    { designacao: 'União das freguesias de Brogueira, Parceiros de Igreja e Alcorochel' },
    { designacao: 'União das freguesias de Olaia e Paço' },
    { designacao: 'União das freguesias de Torres Novas (Santa Maria, Salvador e Santiago)' },
    { designacao: 'União das freguesias de Torres Novas (São Pedro), Lapas e Ribeira Branca' },
    { designacao: 'Zibreira' }
  ],
  'Torres Vedras': [
    { designacao: 'Freiria' },
    { designacao: 'Ponte do Rol' },
    { designacao: 'Ramalhal' },
    { designacao: 'Silveira' },
    { designacao: 'São Pedro da Cadeira' },
    { designacao: 'Turcifal' },
    { designacao: 'União das freguesias de A dos Cunhados e Maceira' },
    { designacao: 'União das freguesias de Campelos e Outeiro da Cabeça' },
    { designacao: 'União das freguesias de Carvoeira e Carmões' },
    { designacao: 'União das freguesias de Dois Portos e Runa' },
    { designacao: 'União das freguesias de Maxial e Monte Redondo' },
    { designacao: 'União das freguesias de Torres Vedras (São Pedro, Santiago, Santa Maria do Castelo e São Miguel) e Matacães' },
    { designacao: 'Ventosa' }
  ],
  'Trancoso': [
    { designacao: 'Aldeia Nova' },
    { designacao: 'Castanheira' },
    { designacao: 'Cogula' },
    { designacao: 'Cótimos' },
    { designacao: 'Fiães' },
    { designacao: 'Granja' },
    { designacao: 'Guilheiro' },
    { designacao: 'Moimentinha' },
    { designacao: 'Moreira de Rei' },
    { designacao: 'Palhais' },
    { designacao: 'Póvoa do Concelho' },
    { designacao: 'Reboleiro' },
    { designacao: 'Rio de Mel' },
    { designacao: 'Tamanhos' },
    { designacao: 'União das freguesias de Freches e Torres' },
    { designacao: 'União das freguesias de Torre do Terrenho, Sebadelhe da Serra e Terrenho' },
    { designacao: 'União das freguesias de Trancoso (São Pedro e Santa Maria) e Souto Maior' },
    { designacao: 'União das freguesias de Vale do Seixo e Vila Garcia' },
    { designacao: 'União das freguesias de Vila Franca das Naves e Feital' },
    { designacao: 'União das freguesias de Vilares e Carnicães' },
    { designacao: 'Valdujo' }
  ],
  'Trofa': [
    { designacao: 'Covelas' },
    { designacao: 'Muro' },
    { designacao: 'União das freguesias de Alvarelhos e Guidões' },
    { designacao: 'União das freguesias de Bougado (São Martinho e Santiago)' },
    { designacao: 'União das freguesias de Coronado (São Romão e São Mamede)' }
  ],
  'Tábua': [
    { designacao: 'Candosa' },
    { designacao: 'Carapinha' },
    { designacao: 'Midões' },
    { designacao: 'Mouronho' },
    { designacao: 'Póvoa de Midões' },
    { designacao: 'São João da Boa Vista' },
    { designacao: 'Tábua' },
    { designacao: 'União das freguesias de Covas e Vila Nova de Oliveirinha' },
    { designacao: 'União das freguesias de Espariz e Sinde' },
    { designacao: 'União das freguesias de Pinheiro de Coja e Meda de Mouros' },
    { designacao: 'União das freguesias de Ázere e Covelo' }
  ],
  'Vagos': [
    { designacao: 'Calvão' },
    { designacao: 'Gafanha da Boa Hora' },
    { designacao: 'Ouca' },
    { designacao: 'Santo André de Vagos' },
    { designacao: 'Sosa' },
    { designacao: 'União das freguesias de Fonte de Angeão e Covão do Lobo' },
    { designacao: 'União das freguesias de Ponte de Vagos e Santa Catarina' },
    { designacao: 'União das freguesias de Vagos e Santo António' }
  ],
  'Vale de Cambra': [
    { designacao: 'Arões' },
    { designacao: 'Cepelos' },
    { designacao: 'Junqueira' },
    { designacao: 'Macieira de Cambra' },
    { designacao: 'Roge' },
    { designacao: 'São Pedro de Castelões' },
    { designacao: 'União das freguesias de Vila Chã, Codal e Vila Cova de Perrinho' }
  ],
  'Valença': [
    { designacao: 'Boivão' },
    { designacao: 'Cerdal' },
    { designacao: 'Fontoura' },
    { designacao: 'Friestas' },
    { designacao: 'Ganfei' },
    { designacao: 'São Pedro da Torre' },
    { designacao: 'União das freguesias de Gandra e Taião' },
    { designacao: 'União das freguesias de Gondomil e Sanfins' },
    { designacao: 'União das freguesias de São Julião e Silva' },
    { designacao: 'União das freguesias de Valença, Cristelo Covo e Arão' },
    { designacao: 'Verdoejo' }
  ],
  'Valongo': [
    { designacao: 'Alfena' },
    { designacao: 'Ermesinde' },
    { designacao: 'União das freguesias de Campo e Sobrado' },
    { designacao: 'Valongo' }
  ],
  'Valpaços': [
    { designacao: 'Algeriz' },
    { designacao: 'Bouçoães' },
    { designacao: 'Canaveses' },
    { designacao: 'Carrazedo de Montenegro e Curros' },
    { designacao: 'Ervões' },
    { designacao: 'Fornos do Pinhal' },
    { designacao: 'Friões' },
    { designacao: 'Lebução, Fiães e Nozelos' },
    { designacao: 'Padrela e Tazem' },
    { designacao: 'Possacos' },
    { designacao: 'Rio Torto' },
    { designacao: 'Santa Maria de Emeres' },
    { designacao: 'Santa Valha' },
    { designacao: 'Santiago da Ribeira de Alhariz' },
    { designacao: 'Serapicos' },
    { designacao: 'Sonim e Barreiros' },
    { designacao: 'São João da Corveira' },
    { designacao: 'São Pedro de Veiga de Lila' },
    { designacao: 'Tinhela e Alvarelhos' },
    { designacao: 'Vales' },
    { designacao: 'Valpaços e Sanfins' },
    { designacao: 'Vassal' },
    { designacao: 'Veiga de Lila' },
    { designacao: 'Vilarandelo' },
    { designacao: 'Água Revés e Crasto' }
  ],
  'Velas': [
    { designacao: 'Manadas (Santa Bárbara)(R.A.Açores)' },
    { designacao: 'Norte Grande (Neves) (R.A.Açores)' },
    { designacao: 'Rosais (R.A.Açores)' },
    { designacao: 'Santo Amaro (R.A.Açores)' },
    { designacao: 'Urzelina (São Mateus) (R.A.Açores)' },
    { designacao: 'Velas (São Jorge) (R.A.Açores)' }
  ],
  'Vendas Novas': [
    { designacao: 'Landeira' },
    { designacao: 'Vendas Novas' }
  ],
  'Viana do Alentejo': [
    { designacao: 'Aguiar' },
    { designacao: 'Alcáçovas' },
    { designacao: 'Viana do Alentejo' }
  ],
  'Viana do Castelo': [
    { designacao: 'Afife' },
    { designacao: 'Alvarães' },
    { designacao: 'Amonde' },
    { designacao: 'Anha' },
    { designacao: 'Areosa' },
    { designacao: 'Carreço' },
    { designacao: 'Castelo do Neiva' },
    { designacao: 'Chafé' },
    { designacao: 'Darque' },
    { designacao: 'Freixieiro de Soutelo' },
    { designacao: 'Lanheses' },
    { designacao: 'Montaria' },
    { designacao: 'Mujães' },
    { designacao: 'Outeiro' },
    { designacao: 'Perre' },
    { designacao: 'Santa Marta de Portuzelo' },
    { designacao: 'União das freguesias de Barroselas e Carvoeiro' },
    { designacao: 'União das freguesias de Cardielos e Serreleis' },
    { designacao: 'União das freguesias de Geraz do Lima (Santa Maria, Santa Leocádia e Moreira) e Deão' },
    { designacao: 'União das freguesias de Mazarefes e Vila Fria' },
    { designacao: 'União das freguesias de Nogueira, Meixedo e Vilar de Murteda' },
    { designacao: 'União das freguesias de Subportela, Deocriste e Portela Susã' },
    { designacao: 'União das freguesias de Torre e Vila Mou' },
    { designacao: 'União das freguesias de Viana do Castelo (Santa Maria Maior e Monserrate) e Meadela' },
    { designacao: 'Vila Franca' },
    { designacao: 'Vila de Punhe' }
  ],
  'Vidigueira': [
    { designacao: 'Pedrógão' },
    { designacao: 'Selmes' },
    { designacao: 'Vidigueira' },
    { designacao: 'Vila de Frades' }
  ],
  'Vieira do Minho': [
    { designacao: 'Cantelães' },
    { designacao: 'Eira Vedra' },
    { designacao: 'Guilhofrei' },
    { designacao: 'Louredo' },
    { designacao: 'Mosteiro' },
    { designacao: 'Parada do Bouro' },
    { designacao: 'Pinheiro' },
    { designacao: 'Rossas' },
    { designacao: 'Salamonde' },
    { designacao: 'Tabuaças' },
    { designacao: 'União das freguesias de Anissó e Soutelo' },
    { designacao: 'União das freguesias de Anjos e Vilar do Chão' },
    { designacao: 'União das freguesias de Caniçada e Soengas' },
    { designacao: 'União das freguesias de Ruivães e Campos' },
    { designacao: 'União das freguesias de Ventosa e Cova' },
    { designacao: 'Vieira do Minho' }
  ],
  'Vila Flor': [
    { designacao: 'Benlhevai' },
    { designacao: 'Freixiel' },
    { designacao: 'Roios' },
    { designacao: 'Sampaio' },
    { designacao: 'Samões' },
    { designacao: 'Santa Comba de Vilariça' },
    { designacao: 'Seixo de Manhoses' },
    { designacao: 'Trindade' },
    { designacao: 'União das freguesias de Assares e Lodões' },
    { designacao: 'União das freguesias de Candoso e Carvalho de Egas' },
    { designacao: 'União das freguesias de Valtorno e Mourão' },
    { designacao: 'União das freguesias de Vila Flor e Nabo' },
    { designacao: 'União das freguesias de Vilas Boas e Vilarinho das Azenhas' },
    { designacao: 'Vale Frechoso' }
  ],
  'Vila Franca de Xira': [
    { designacao: 'União das freguesias de Alhandra, São João dos Montes e Calhandriz' },
    { designacao: 'União das freguesias de Alverca do Ribatejo e Sobralinho' },
    { designacao: 'União das freguesias de Castanheira do Ribatejo e Cachoeiras' },
    { designacao: 'União das freguesias de Póvoa de Santa Iria e Forte da Casa' },
    { designacao: 'Vialonga' },
    { designacao: 'Vila Franca de Xira' }
  ],
  'Vila Franca do Campo': [
    { designacao: 'Ponta Garça' },
    { designacao: 'Ribeira Seca' },
    { designacao: 'Ribeira das Tainhas' },
    { designacao: 'Vila Franca do Campo (São Miguel)' },
    { designacao: 'Vila Franca do Campo (São Pedro)' },
    { designacao: 'Água de Alto' }
  ],
  'Vila Nova da Barquinha': [
    { designacao: 'Atalaia' },
    { designacao: 'Praia do Ribatejo' },
    { designacao: 'Tancos' },
    { designacao: 'Vila Nova da Barquinha' }
  ],
  'Vila Nova de Cerveira': [
    { designacao: 'Cornes' },
    { designacao: 'Covas' },
    { designacao: 'Gandra' },
    { designacao: 'Gondarém' },
    { designacao: 'Loivo' },
    { designacao: 'Mentrestido' },
    { designacao: 'Sapardos' },
    { designacao: 'Sopo' },
    { designacao: 'União das freguesias de Campos e Vila Meã' },
    { designacao: 'União das freguesias de Candemil e Gondar' },
    { designacao: 'União das freguesias de Reboreda e Nogueira' },
    { designacao: 'União das freguesias de Vila Nova de Cerveira e Lovelhe' }
  ],
  'Vila Nova de Famalicão': [
    { designacao: 'Bairro' },
    { designacao: 'Brufe' },
    { designacao: 'Castelões' },
    { designacao: 'Cruz' },
    { designacao: 'Delães' },
    { designacao: 'Fradelos' },
    { designacao: 'Gavião' },
    { designacao: 'Joane' },
    { designacao: 'Landim' },
    { designacao: 'Louro' },
    { designacao: 'Lousado' },
    { designacao: 'Mogege' },
    { designacao: 'Nine' },
    { designacao: 'Oliveira (Santa Maria)' },
    { designacao: 'Pedome' },
    { designacao: 'Pousada de Saramagos' },
    { designacao: 'Requião' },
    { designacao: 'Riba de Ave' },
    { designacao: 'Ribeirão' },
    { designacao: 'União das freguesias de Antas e Abade de Vermoim' },
    { designacao: 'União das freguesias de Arnoso (Santa Maria e Santa Eulália) e Sezures' },
    { designacao: 'União das freguesias de Avidos e Lagoa' },
    { designacao: 'União das freguesias de Carreira e Bente' },
    { designacao: 'União das freguesias de Esmeriz e Cabeçudos' },
    { designacao: 'União das freguesias de Gondifelos, Cavalões e Outiz' },
    { designacao: 'União das freguesias de Lemenhe, Mouquim e Jesufrei' },
    { designacao: 'União das freguesias de Ruivães e Novais' },
    { designacao: 'União das freguesias de Seide' },
    { designacao: 'União das freguesias de Vale (São Cosme), Telhado e Portela' },
    { designacao: 'União das freguesias de Vila Nova de Famalicão e Calendário' },
    { designacao: 'Vale (São Martinho)' },
    { designacao: 'Vermoim' },
    { designacao: 'Vilarinho das Cambas' }
  ],
  'Vila Nova de Foz Côa': [
    { designacao: 'Almendra' },
    { designacao: 'Castelo Melhor' },
    { designacao: 'Cedovim' },
    { designacao: 'Chãs' },
    { designacao: 'Custóias' },
    { designacao: 'Freixo de Numão' },
    { designacao: 'Horta' },
    { designacao: 'Muxagata' },
    { designacao: 'Numão' },
    { designacao: 'Santa Comba' },
    { designacao: 'Sebadelhe' },
    { designacao: 'Seixas' },
    { designacao: 'Touça' },
    { designacao: 'Vila Nova de Foz Côa' }
  ],
  'Vila Nova de Gaia': [
    { designacao: 'Arcozelo' },
    { designacao: 'Avintes' },
    { designacao: 'Canelas' },
    { designacao: 'Canidelo' },
    { designacao: 'Madalena' },
    { designacao: 'Oliveira do Douro' },
    { designacao: 'São Félix da Marinha' },
    { designacao: 'União das freguesias de Grijó e Sermonde' },
    { designacao: 'União das freguesias de Gulpilhares e Valadares' },
    { designacao: 'União das freguesias de Mafamude e Vilar do Paraíso' },
    { designacao: 'União das freguesias de Pedroso e Seixezelo' },
    { designacao: 'União das freguesias de Sandim, Olival, Lever e Crestuma' },
    { designacao: 'União das freguesias de Santa Marinha e São Pedro da Afurada' },
    { designacao: 'União das freguesias de Serzedo e Perosinho' },
    { designacao: 'Vilar de Andorinho' }
  ],
  'Vila Nova de Paiva': [
    { designacao: 'Pendilhe' },
    { designacao: 'Queiriga' },
    { designacao: 'Touro' },
    { designacao: 'União das freguesias de Vila Nova de Paiva, Alhais e Fráguas' },
    { designacao: 'Vila Cova à Coelheira' }
  ],
  'Vila Nova de Poiares': [
    { designacao: 'Arrifana' },
    { designacao: 'Lavegadas' },
    { designacao: 'Poiares (Santo André)' },
    { designacao: 'São Miguel de Poiares' }
  ],
  'Vila Pouca de Aguiar': [
    { designacao: 'Alfarela de Jales' },
    { designacao: 'Alvão' },
    { designacao: 'Bornes de Aguiar' },
    { designacao: 'Bragado' },
    { designacao: 'Capeludos' },
    { designacao: 'Sabroso de Aguiar' },
    { designacao: 'Soutelo de Aguiar' },
    { designacao: 'Telões' },
    { designacao: 'Tresminas' },
    { designacao: 'União das freguesias de Pensalvos e Parada de Monteiros' },
    { designacao: 'Valoura' },
    { designacao: 'Vila Pouca de Aguiar' },
    { designacao: 'Vreia de Bornes' },
    { designacao: 'Vreia de Jales' }
  ],
  'Vila Real': [
    { designacao: 'Abaças' },
    { designacao: 'Andrães' },
    { designacao: 'Arroios' },
    { designacao: 'Campeã' },
    { designacao: 'Folhadela' },
    { designacao: 'Guiães' },
    { designacao: 'Lordelo' },
    { designacao: 'Mateus' },
    { designacao: 'Mondrões' },
    { designacao: 'Parada de Cunhos' },
    { designacao: 'Torgueda' },
    { designacao: 'União das freguesias de Adoufe e Vilarinho de Samardã' },
    { designacao: 'União das freguesias de Borbela e Lamas de Olo' },
    { designacao: 'União das freguesias de Constantim e Vale de Nogueiras' },
    { designacao: 'União das freguesias de Mouçós e Lamares' },
    { designacao: 'União das freguesias de Nogueira e Ermida' },
    { designacao: 'União das freguesias de Pena, Quintã e Vila Cova' },
    { designacao: 'União das freguesias de São Tomé do Castelo e Justes' },
    { designacao: 'União das freguesias de Vila Real (Nossa Senhora da Conceição, São Pedro e São Dinis)' },
    { designacao: 'Vila Marim' }
  ],
  'Vila Real de Santo António': [
    { designacao: 'Monte Gordo' },
    { designacao: 'Vila Nova de Cacela' },
    { designacao: 'Vila Real de Santo António' }
  ],
  'Vila Velha de Ródão': [
    { designacao: 'Fratel' },
    { designacao: 'Perais' },
    { designacao: 'Sarnadas de Ródão' },
    { designacao: 'Vila Velha de Ródão' }
  ],
  'Vila Verde': [
    { designacao: 'Aboim da Nóbrega e Gondomar' },
    { designacao: 'Atiães' },
    { designacao: 'Cabanelas' },
    { designacao: 'Cervães' },
    { designacao: 'Coucieiro' },
    { designacao: 'Dossãos' },
    { designacao: 'Freiriz' },
    { designacao: 'Gême' },
    { designacao: 'Lage' },
    { designacao: 'Lanhas' },
    { designacao: 'Loureira' },
    { designacao: 'Moure' },
    { designacao: 'Oleiros' },
    { designacao: 'Parada de Gatim' },
    { designacao: 'Pico' },
    { designacao: 'Ponte' },
    { designacao: 'Prado (São Miguel)' },
    { designacao: 'Sabariz' },
    { designacao: 'Soutelo' },
    { designacao: 'Turiz' },
    { designacao: 'União das freguesias da Ribeira do Neiva' },
    { designacao: 'União das freguesias de Carreiras (São Miguel) e Carreiras (Santiago)' },
    { designacao: 'União das freguesias de Escariz (São Mamede) e Escariz (São Martinho)' },
    { designacao: 'União das freguesias de Esqueiros, Nevogilde e Travassós' },
    { designacao: 'União das freguesias de Marrancos e Arcozelo' },
    { designacao: 'União das freguesias de Oriz (Santa Marinha) e Oriz (São Miguel)' },
    { designacao: 'União das freguesias de Pico de Regalados, Gondiães e Mós' },
    { designacao: 'União das freguesias de Sande, Vilarinho, Barros e Gomide' },
    { designacao: 'União das freguesias de Valbom (São Pedro), Passô e Valbom (São Martinho)' },
    { designacao: 'União das freguesias do Vade' },
    { designacao: 'Valdreu' },
    { designacao: 'Vila Verde e Barbudo' },
    { designacao: 'Vila de Prado' }
  ],
  'Vila Viçosa': [
    { designacao: 'Bencatel' },
    { designacao: 'Ciladas' },
    { designacao: 'Nossa Senhora da Conceição e São Bartolomeu' },
    { designacao: 'Pardais' }
  ],
  'Vila de Rei': [
    { designacao: 'Fundada' },
    { designacao: 'São João do Peso' },
    { designacao: 'Vila de Rei' }
  ],
  'Vila do Bispo': [
    { designacao: 'Barão de São Miguel' },
    { designacao: 'Budens' },
    { designacao: 'Sagres' },
    { designacao: 'Vila do Bispo e Raposeira' }
  ],
  'Vila do Conde': [
    { designacao: 'Aveleda' },
    { designacao: 'Azurara' },
    { designacao: 'Fajozes' },
    { designacao: 'Gião' },
    { designacao: 'Guilhabreu' },
    { designacao: 'Junqueira' },
    { designacao: 'Labruge' },
    { designacao: 'Macieira da Maia' },
    { designacao: 'Mindelo' },
    { designacao: 'Modivas' },
    { designacao: 'União das freguesias de Bagunte, Ferreiró, Outeiro Maior e Parada' },
    { designacao: 'União das freguesias de Fornelo e Vairão' },
    { designacao: 'União das freguesias de Malta e Canidelo' },
    { designacao: 'União das freguesias de Retorta e Tougues' },
    { designacao: 'União das freguesias de Rio Mau e Arcos' },
    { designacao: 'União das freguesias de Touguinha e Touguinhó' },
    { designacao: 'União das freguesias de Vilar e Mosteiró' },
    { designacao: 'Vila Chã' },
    { designacao: 'Vila do Conde' },
    { designacao: 'Vilar de Pinheiro' },
    { designacao: 'Árvore' }
  ],
  'Vila do Porto': [
    { designacao: 'Almagreira' },
    { designacao: 'Santa Bárbara' },
    { designacao: 'Santo Espírito' },
    { designacao: 'São Pedro' },
    { designacao: 'Vila do Porto' }
  ],
  'Vimioso': [
    { designacao: 'Argozelo' },
    { designacao: 'Carção' },
    { designacao: 'Matela' },
    { designacao: 'Pinelo' },
    { designacao: 'Santulhão' },
    { designacao: 'União das freguesias de Algoso, Campo de Víboras e Uva' },
    { designacao: 'União das freguesias de Caçarelhos e Angueira' },
    { designacao: 'União das freguesias de Vale de Frades e Avelanoso' },
    { designacao: 'Vilar Seco' },
    { designacao: 'Vimioso' }
  ],
  'Vinhais': [
    { designacao: 'Agrochão' },
    { designacao: 'Candedo' },
    { designacao: 'Celas' },
    { designacao: 'Edral' },
    { designacao: 'Edrosa' },
    { designacao: 'Ervedosa' },
    { designacao: 'Paçó' },
    { designacao: 'Penhas Juntas' },
    { designacao: 'Rebordelo' },
    { designacao: 'Santalha' },
    { designacao: 'Tuizelo' },
    { designacao: 'União das freguesias de Curopos e Vale de Janeiro' },
    { designacao: 'União das freguesias de Moimenta e Montouto' },
    { designacao: 'União das freguesias de Nunes e Ousilhão' },
    { designacao: 'União das freguesias de Quirás e Pinheiro Novo' },
    { designacao: 'União das freguesias de Sobreiro de Baixo e Alvaredos' },
    { designacao: 'União das freguesias de Soeira, Fresulfe e Mofreita' },
    { designacao: 'União das freguesias de Travanca e Santa Cruz' },
    { designacao: 'União das freguesias de Vilar de Lomba e São Jomil' },
    { designacao: 'Vale das Fontes' },
    { designacao: 'Vila Boa de Ousilhão' },
    { designacao: 'Vila Verde' },
    { designacao: 'Vilar Seco de Lomba' },
    { designacao: 'Vilar de Ossos' },
    { designacao: 'Vilar de Peregrinos' },
    { designacao: 'Vinhais' }
  ],
  'Viseu': [
    { designacao: 'Abraveses' },
    { designacao: 'Bodiosa' },
    { designacao: 'Calde' },
    { designacao: 'Campo' },
    { designacao: 'Cavernães' },
    { designacao: 'Cota' },
    { designacao: 'Fragosela' },
    { designacao: 'Lordosa' },
    { designacao: 'Mundão' },
    { designacao: 'Orgens' },
    { designacao: 'Povolide' },
    { designacao: 'Ranhados' },
    { designacao: 'Ribafeita' },
    { designacao: 'Rio de Loba' },
    { designacao: 'Santos Evos' },
    { designacao: 'Silgueiros' },
    { designacao: 'São João de Lourosa' },
    { designacao: 'São Pedro de France' },
    { designacao: 'União das freguesias de Barreiros e Cepões' },
    { designacao: 'União das freguesias de Boa Aldeia, Farminhão e Torredeita' },
    { designacao: 'União das freguesias de Couto de Baixo e Couto de Cima' },
    { designacao: 'União das freguesias de Faíl e Vila Chã de Sá' },
    { designacao: 'União das freguesias de Repeses e São Salvador' },
    { designacao: 'União das freguesias de São Cipriano e Vil de Souto' },
    { designacao: 'União das freguesias de Viseu' }
  ],
  'Vizela': [
    { designacao: 'Infias' },
    { designacao: 'Santa Eulália' },
    { designacao: 'Selho (São Jorge)' },
    { designacao: 'União das freguesias de Conde e Gandarela' },
    { designacao: 'União das freguesias de Tagilde e Vizela (São Paio)' },
    { designacao: 'Vizela (Santo Adrião)' }
  ],
  'Vouzela': [
    { designacao: 'Alcofra' },
    { designacao: 'Campia' },
    { designacao: 'Fornelo do Monte' },
    { designacao: 'Queirã' },
    { designacao: 'São Miguel do Mato' },
    { designacao: 'União das freguesias de Cambra e Carvalhal de Vermilhas' },
    { designacao: 'União das freguesias de Fataunços e Figueiredo das Donas' },
    { designacao: 'União das freguesias de Vouzela e Paços de Vilharigues' },
    { designacao: 'Ventosa' }
  ],
  'Águeda': [
    { designacao: 'Aguada de Cima' },
    { designacao: 'Fermentelos' },
    { designacao: 'Macinhata do Vouga' },
    { designacao: 'União das freguesias de Barrô e Aguada de Baixo' },
    { designacao: 'União das freguesias de Belazaima do Chão, Castanheira do Vouga e Agadão' },
    { designacao: 'União das freguesias de Recardães e Espinhel' },
    { designacao: 'União das freguesias de Travassô e Óis da Ribeira' },
    { designacao: 'União das freguesias de Trofa, Segadães e Lamas do Vouga' },
    { designacao: 'União das freguesias de Águeda e Borralha' },
    { designacao: 'União das freguesias do Préstimo e Macieira de Alcoba' },
    { designacao: 'Valongo do Vouga' }
  ],
  'Évora': [
    { designacao: 'Canaviais' },
    { designacao: 'Nossa Senhora da Graça do Divor' },
    { designacao: 'Nossa Senhora de Machede' },
    { designacao: 'São Bento do Mato' },
    { designacao: 'São Miguel de Machede' },
    { designacao: 'Torre de Coelheiros' },
    { designacao: 'União das freguesias de Bacelo e Senhora da Saúde' },
    { designacao: 'União das freguesias de Malagueira e Horta das Figueiras' },
    { designacao: 'União das freguesias de Nossa Senhora da Tourega e Nossa Senhora de Guadalupe' },
    { designacao: 'União das freguesias de São Manços e São Vicente do Pigeiro' },
    { designacao: 'União das freguesias de São Sebastião da Giesteira e Nossa Senhora da Boa Fé' },
    { designacao: 'União das freguesias de Évora (São Mamede, Sé, São Pedro e Santo Antão)' }
  ],
  'Ílhavo': [
    { designacao: 'Gafanha da Encarnação' },
    { designacao: 'Gafanha da Nazaré' },
    { designacao: 'Gafanha do Carmo' },
    { designacao: 'Ílhavo (São Salvador)' }
  ],
  'Óbidos': [
    { designacao: 'A dos Negros' },
    { designacao: 'Amoreira' },
    { designacao: 'Gaeiras' },
    { designacao: 'Olho Marinho' },
    { designacao: 'Santa Maria, São Pedro e Sobral da Lagoa' },
    { designacao: 'Usseira' },
    { designacao: 'Vau' }
  ]
};

export default freguesias;
